// ============================================================
// CreateExamAI.jsx - نسخه نهایی با نمره‌دهی دقیق ۲۰
// ============================================================

import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import './CreateExamAI.css';
import { useExams, toNumber, sanitizeHtml as sanitizeHtmlGlobal, isGlobalAdmin } from './ExamContext.jsx';
import moment from 'moment-jalaali';
import html2pdf from 'html2pdf.js';
import { useAuth } from '../../context/AuthContext.jsx';
import { uploadImage, deleteImage, getImageUrl, moveExamImages } from '../../services/ImageService';
import { FiCpu, FiZap, FiStar, FiSend, FiRefreshCw, FiEdit, FiCopy, FiTrash2, FiArrowUp, FiArrowDown } from 'react-icons/fi';

// 🆕 AI Quota System (Backend-Sync)
import {
  FREE_DAILY_LIMIT,
  getQuota as getAIQuota,
  getSubscription as getAISubscription,
  canGenerate as canGenerateAI,
  consumeQuota as consumeAIQuota,
  refundQuota as refundAIQuota,
  AI_PLANS,
  formatExpiry as formatAIExpiry,
} from '../../services/aiQuotaService';
import { startPayment, PAYMENT_PURPOSE } from '../../services/paymentService';

// 🔽 CHANGED: curriculum helpers برای پشتیبانی از پایه ۷-۱۲ و رشته‌های متوسطه دوم
import {
  GRADE_LIST,
  FIELD_LIST,
  getGrade as getGradeMeta,
  getField as getFieldMeta,
  getSubjectTitle,
  getSubjectsFor,
  needsField as curriculumNeedsField,
  normalizeFieldId as curriculumNormalizeField,
} from '../../core/education/curriculum.js';


// ===== توابع کمکی =====
const toPersianDigits = (num) => {
  if (num === undefined || num === null) return '';
  const id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return num.toString().replace(/[0-9]/g, (w) => id[+w]);
};

const toPersianLetter = (letter) => {
  const map = {
    'A': 'الف', 'B': 'ب', 'C': 'پ', 'D': 'ت',
    'E': 'ث', 'F': 'ج', 'G': 'چ', 'H': 'ح',
    'I': 'خ', 'J': 'د', 'K': 'ذ', 'L': 'ر',
    'M': 'ز', 'N': 'ژ', 'O': 'س', 'P': 'ش',
    'Q': 'ص', 'R': 'ض', 'S': 'ط', 'T': 'ظ',
    'U': 'ع', 'V': 'غ', 'W': 'ف', 'X': 'ق',
    'Y': 'ک', 'Z': 'گ'
  };
  return map[letter] || letter;
};

const classNames = (...classes) => classes.filter(Boolean).join(' ');

// ===== داده‌های آموزشی =====
const curriculumData = {
  "پایه اول": {
    books: {
      "ریاضی": { chapters: ["فصل ۱", "فصل ۲", "فصل ۳", "فصل ۴", "فصل ۵", "فصل ۶", "فصل ۷", "فصل ۸", "فصل ۹", "فصل ۱۰", "فصل ۱۱", "فصل ۱۲", "فصل ۱۳", "فصل ۱۴", "فصل ۱۵", "فصل ۱۶", "فصل ۱۷", "فصل ۱۸", "فصل ۱۹", "فصل ۲۰", "فصل ۲۱", "فصل ۲۲", "فصل ۲۳", "فصل ۲۴"], lessons: ["درس زمین خانه سنگی ما","درس اول:زیبایی ها"] },
      "علوم": { chapters: ["فصل ۱: زنگ علوم", "فصل ۲: سلام,به من نگاه کن", "فصل ۳: سالم باش,شاداب باش", "فصل ۴: دنیای جانوران", "فصل ۵: دنیای گیاهان", "فصل ۶: زمین خانه پر از آب ما", "فصل ۷: زمین خانه سنگی ما", "فصل ۸: چه میخواهم بسازم", "فصل ۹: زمین خانه خاکی ما", "فصل ۱۰: در اطراف ما هوا وجود دارد", "فصل ۱۱: دنیای سرد و گرم", "فصل ۱۲: از خانه تا مدرسه", "فصل ۱۳: آهن ربای من", "فصل ۱۴: از گذشته تا آینده"], lessons: [""] },
      "فارسی": { chapters: ["بخش ۱: نگاره‌ها", "بخش ۲:آموزش نشانه‌ها۱", "بخش ۳:آموزش نشانه‌ها۲", "بخش ۴: روان خوانی"], lessons: ["درس ۱: آ - ب", "درس ۲: اَ - د", "درس ۳: م - س", "درس ۴: او - ت", "درس ۵: ر - ن", "درس ۶: ای - ز", "درس ۷: اِ - ش", "درس ۸: ی - اُ", "درس ۹: ک - و", "درس ۱۰: پ - گ", "درس ۱۱: ف - خ", "درس ۱۲: ق - ل", "درس ۱۳: ج - _ُ", "درس ۱۴: ه - چ", "درس ۱۵: ژ - خوا", "درس ۱۶: تشدید", "درس ۱۷: ص - ذ", "درس ۱۸: ع - ث", "درس ۱۹: ح ", "درس ۲۰: ض - ط", "درس ۲۱: غ", "درس ۲۲: ظ"] },
      "قرآن": { chapters: ["درس ۱: به نام خدا بسم الله (سوره توحید)", "درس ۲: نعمت های خدا (سوره کوثر)", "درس ۳: خانه ما (سوره عصر)", "درس ۴: قرآن بخوانیم (سوره ناس)", "درس ۵: کودک مسلمان (سوره حمد)", "درس ۶: مدرسه ما (سوره فلق)", "درس ۷: پیامبران خدا (سوره نصر)", "درس ۸: سوره ها "], lessons: [""] }
    }
  },
  "پایه دوم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: عدد و رقم", "فصل ۲: جمع و تفریق اعداد دو رقمی", "فصل ۳: اشکال هندسی", "فصل ۴: عدد های سه رقمی", "فصل ۵: اندازه گیری", "فصل ۶: جمع و تفریق اعداد سه رقمی", "فصل ۷: کسر و احتمال ", "فصل ۸: آمار و نمودار"], lessons: [] },
      "علوم": { chapters: ["فصل ۱: جانوران", "فصل ۲: گیاهان"], lessons: ["درس ۱: حیوانات خانگی", "درس ۲: گیاهان اطراف ما"] },
      "فارسی": { chapters: ["فصل ۱: نشانه‌ها", "فصل ۲: جمله‌سازی"], lessons: ["درس ۱: نشانه‌های جدید", "درس ۲: جمله‌های ساده"] }
    }
  },
  "پایه سوم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: الگوها", "فصل ۲: ضرب"], lessons: ["درس ۱: الگوی عددی", "درس ۲: جدول ضرب"] },
      "علوم": { chapters: ["فصل ۱: مواد", "فصل ۲: انرژی"], lessons: ["درس ۱: مواد اطراف", "درس ۲: گرما و نور"] },
      "فارسی": { chapters: ["فصل ۱: خواندنی‌ها", "فصل ۲: نوشتنی‌ها"], lessons: ["درس ۱: داستان‌های آموزنده", "درس ۲: انشا ساده"] }
    }
  },
  "پایه چهارم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: اعداد بزرگ", "فصل ۲: تقسیم"], lessons: ["درس ۱: عددنویسی تا ۱۰۰۰", "درس ۲: تقسیم با باقیمانده"] },
      "علوم": { chapters: ["فصل ۱: بدن انسان", "فصل ۲: زمین"], lessons: ["درس ۱: دستگاه گوارش", "درس ۲: لایه‌های زمین"] },
      "فارسی": { chapters: ["فصل ۱: حکایت‌ها", "فصل ۲: شعرها"], lessons: ["درس ۱: حکایت گلستان", "درس ۲: شعر پروین"] }
    }
  },
  "پایه پنجم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: اعشار", "فصل ۲: درصد"], lessons: ["درس ۱: اعداد اعشاری", "درس ۲: محاسبه درصد"] },
      "علوم": { chapters: ["فصل ۱: سلول", "فصل ۲: نور"], lessons: ["درس ۱: سلول‌های بدن", "درس ۲: بازتاب نور"] },
      "فارسی": { chapters: ["فصل ۱: متون ادبی", "فصل ۲: نگارش"], lessons: ["درس ۱: متن‌های کهن", "درس ۲: نوشتن نامه"] }
    }
  },
  "پایه ششم": {
    books: {
      "ریاضی": { chapters: ["فصل ۱: کسرها", "فصل ۲: نسبت"], lessons: ["درس ۱: جمع و تفریق کسر", "درس ۲: نسبت و تناسب"] },
      "علوم": { chapters: ["فصل ۱: الکتریسیته", "فصل ۲: مواد"], lessons: ["درس ۱: مدار الکتریکی", "درس ۲: تغییرات مواد"] },
      "فارسی": { chapters: ["فصل ۱: شاهنامه", "فصل ۲: ادبیات معاصر"], lessons: ["درس ۱: داستان رستم", "درس ۲: شعر نیما"] }
    }
  },
};



// ============================================================
// 🔽 CHANGED: داده‌ی خودکار برای پایه‌های ۷-۱۲ از curriculum
// ----------------------------------------------------------------
// • برای ۷-۹: ساختار تخت (فقط books)
// • برای ۱۰-۱۲: ساختار تو در تو (fields → books)
// ============================================================

const GENERIC_CHAPTERS_9_12 = [
  'فصل ۱', 'فصل ۲', 'فصل ۳', 'فصل ۴', 'فصل ۵', 'فصل ۶',
  'فصل ۷', 'فصل ۸', 'فصل ۹', 'فصل ۱۰',
];

GRADE_LIST
  .filter((g) => ['7', '8', '9'].includes(g.id))
  .forEach((g) => {
    const books = {};
    getSubjectsFor(g.id).forEach((s) => {
      books[s.title] = {
        chapters: [...GENERIC_CHAPTERS_9_12],
        lessons: [],
      };
    });
    if (!curriculumData[g.title]) {
      curriculumData[g.title] = { books };
    }
  });

GRADE_LIST
  .filter((g) => ['10', '11', '12'].includes(g.id))
  .forEach((g) => {
    const fields = {};
    FIELD_LIST.forEach((f) => {
      const books = {};
      getSubjectsFor(g.id, f.id).forEach((s) => {
        const bookTitle = getSubjectTitle(g.id, s.id);
        books[bookTitle] = {
          chapters: [...GENERIC_CHAPTERS_9_12],
          lessons: [],
        };
      });
      fields[f.title] = { books };
    });
    if (!curriculumData[g.title]) {
      curriculumData[g.title] = { fields };
    }
  });

// 🔽 CHANGED: gradeOptions از curriculum برای ترتیب درست
const gradeOptions = GRADE_LIST.map((g) => g.title);





/**
 * تولید سوالات کمبود برای یک نوع خاص
 */
const generateMissingQuestions = async (type, count, grade, book, chapter, subject, difficulty) => {
  const difficultyLabels = {
    1: 'خیلی آسان',
    2: 'آسان',
    3: 'متوسط',
    4: 'سخت',
    5: 'خیلی سخت'
  };

  let typeDescription = '';
  let extraFields = '';
  
  switch (type) {
    case 'multiple':
      typeDescription = 'تستی تک‌انتخابی با ۴ گزینه';
      extraFields = '"options": ["گزینه۱", "گزینه۲", "گزینه۳", "گزینه۴"], "correctAnswer": 0';
      break;
    case 'multi':
      typeDescription = 'تستی چندانتخابی با ۴ گزینه';
      extraFields = '"options": ["گزینه۱", "گزینه۲", "گزینه۳", "گزینه۴"], "correctAnswers": [0, 2]';
      break;
    case 'truefalse':
      typeDescription = 'صحیح/غلط';
      extraFields = '"correctAnswer": 0';
      break;
    case 'fill':
      typeDescription = 'جای خالی';
      extraFields = '"fillAnswers": ["پاسخ صحیح"]';
      break;
    case 'essay':
      typeDescription = 'تشریحی';
      extraFields = '';
      break;
    case 'matching':
      typeDescription = 'تطبیقی';
      extraFields = '"matchingPairs": [{ "left": "سمت چپ", "right": "سمت راست" }]';
      break;
    case 'ordering':
      typeDescription = 'مرتب‌سازی';
      extraFields = '"orderItems": ["آیتم۱", "آیتم۲", "آیتم۳", "آیتم۴"]';
      break;
    default:
      throw new Error(`نوع سوال نامشخص: ${type}`);
  }

  const prompt = `
    لطفاً دقیقاً ${count} سوال از نوع "${typeDescription}" برای پایه ${grade}، کتاب ${book}، فصل ${chapter} و درس ${subject} با سطح دشواری ${difficultyLabels[difficulty]} تولید کنید.
    سوالات باید جدید، متنوع و کاملاً مرتبط با محتوای کتاب درسی باشند.
    
    ساختار JSON خروجی:
    [
      {
        "type": "${type}",
        "question": "متن سوال",
        ${extraFields}
      }
    ]
    
    توجه: فقط JSON برگردانید و هیچ توضیح اضافی ندهید.
    برای سوالات تشریحی، فقط متن سوال کافی است.
    برای سوالات تطبیقی، حداقل ۳ جفت ارائه دهید.
    برای سوالات مرتب‌سازی، حداقل ۴ آیتم ارائه دهید.
  `;

  const response = await fetch('/api/ai/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      model: 'gpt-4o-mini',
      messages: [
        { role: 'system', content: 'شما یک معلم حرفه‌ای هستید که سوالات استاندارد بر اساس کتاب درسی ایران تولید می‌کنید.' },
        { role: 'user', content: prompt }
      ],
      temperature: 0.5,
      max_tokens: 2000,
    }),
  });

  if (!response.ok) {
    throw new Error(`خطا در ارتباط با سرور: ${response.status}`);
  }

  const data = await response.json();
  const content = data.choices[0].message.content.trim();

  let jsonString = content;
  const jsonMatch = content.match(/```(?:json)?\s*([\s\S]*?)\s*```/);
  if (jsonMatch) {
    jsonString = jsonMatch[1];
  }

  const generated = JSON.parse(jsonString);
  if (!Array.isArray(generated) || generated.length === 0) {
    throw new Error('هیچ سوالی تولید نشد.');
  }

  return generated.map((q, index) => {
    const id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9) + index;
    const base = {
      id,
      type: q.type,
      question: sanitizeHtmlGlobal(q.question),
      score: 1, // موقتاً ۱
      image: null,
      file: null,
      required: false,
      timeLimit: null,
      conditional: null,
      mathFormula: q.mathFormula || '',
      isEssay: q.type === 'essay' || q.type === 'file',
    };

    switch (q.type) {
      case 'multiple':
        return {
          ...base,
          options: q.options || ['', '', '', ''],
          correctAnswer: q.correctAnswer !== undefined ? q.correctAnswer : 0,
          correctAnswers: [],
          fillAnswers: [],
          matchingPairs: [],
          orderItems: [],
        };
      case 'multi':
        return {
          ...base,
          options: q.options || ['', '', '', ''],
          correctAnswer: 0,
          correctAnswers: q.correctAnswers || [0],
          fillAnswers: [],
          matchingPairs: [],
          orderItems: [],
        };
      case 'truefalse':
        return {
          ...base,
          options: ['صحیح', 'غلط'],
          correctAnswer: q.correctAnswer === 0 ? 0 : 1,
          correctAnswers: [],
          fillAnswers: [],
          matchingPairs: [],
          orderItems: [],
        };
      case 'fill':
        return {
          ...base,
          options: [],
          correctAnswer: 0,
          correctAnswers: [],
          fillAnswers: q.fillAnswers || [''],
          matchingPairs: [],
          orderItems: [],
        };
      case 'essay':
        return {
          ...base,
          options: [],
          correctAnswer: 0,
          correctAnswers: [],
          fillAnswers: [],
          matchingPairs: [],
          orderItems: [],
        };
      case 'matching':
        return {
          ...base,
          options: [],
          correctAnswer: 0,
          correctAnswers: [],
          fillAnswers: [],
          matchingPairs: q.matchingPairs || [{ left: '', right: '' }],
          orderItems: [],
        };
      case 'ordering':
        return {
          ...base,
          options: [],
          correctAnswer: 0,
          correctAnswers: [],
          fillAnswers: [],
          matchingPairs: [],
          orderItems: q.orderItems || ['', '', '', ''],
        };
      default:
        throw new Error(`نوع سوال نامشخص: ${q.type}`);
    }
  });
};

// ============================================================
// ===== تابع نمره‌دهی هوشمند با تضمین مجموع = ۲۰ =====
// ============================================================
const assignScores = (questions) => {
  if (!questions || questions.length === 0) return questions;

  // تعیین وزن، پله، min و max برای هر نوع
  const getWeight = (type) => {
    switch (type) {
      case 'essay':
      case 'file':
      case 'matching':
      case 'ordering':
        return 2.5;
      case 'multiple':
      case 'multi':
        return 1.0;
      case 'truefalse':
      case 'fill':
        return 0.75;
      default:
        return 1.0;
    }
  };

  const getStep = (type) => {
    const isHeavy = ['essay', 'file', 'matching', 'ordering'].includes(type);
    return isHeavy ? 0.5 : 0.25;
  };

  const getMinScore = (type) => {
    const isHeavy = ['essay', 'file', 'matching', 'ordering'].includes(type);
    return isHeavy ? 1 : 0.25;
  };

  const getMaxScore = (type) => {
    const isHeavy = ['essay', 'file', 'matching', 'ordering'].includes(type);
    return isHeavy ? 3 : 1;
  };

  // محاسبه وزن کل
  let totalWeight = 0;
  questions.forEach(q => { totalWeight += getWeight(q.type); });
  if (totalWeight === 0) return questions;

  // تابع گرد کردن به پله
  const roundToStep = (value, type) => {
    const step = getStep(type);
    return Math.round(value / step) * step;
  };

  // تابع محدود کردن به بازه مجاز
  const clampScore = (value, type) => {
    const min = getMinScore(type);
    const max = getMaxScore(type);
    return Math.min(Math.max(value, min), max);
  };

  // ۱. محاسبه نمرات خام و گرد شده
  let scores = questions.map((q, idx) => {
    const raw = (getWeight(q.type) / totalWeight) * 20;
    const rounded = roundToStep(raw, q.type);
    return clampScore(rounded, q.type);
  });

  // ۲. محاسبه مجموع فعلی
  let sum = scores.reduce((a, b) => a + b, 0);

  // ۳. اگر مجموع بیشتر از ۲۰ است، کم کنیم
  if (sum > 20 + 0.001) {
    // مرتب‌سازی بر اساس نمره (نزولی) و اولویت با سوالاتی که بیشترین نمره رو دارن
    let indices = Array.from({ length: questions.length }, (_, i) => i);
    indices.sort((a, b) => scores[b] - scores[a]);

    let diff = sum - 20;
    for (let idx of indices) {
      if (diff < 0.001) break;
      const type = questions[idx].type;
      const step = getStep(type);
      const minScore = getMinScore(type);
      // اگر نمره از حداقل بیشتر است، یک پله کم کنیم
      if (scores[idx] - step >= minScore - 0.001) {
        const newScore = Math.round((scores[idx] - step) / step) * step;
        const clamped = clampScore(newScore, type);
        const decrease = scores[idx] - clamped;
        if (decrease > 0.001) {
          scores[idx] = clamped;
          diff -= decrease;
        }
      }
    }
    // اگر همچنان diff مثبت است، از اولین سوالی که امکان کاهش داره کم می‌کنیم (با دقت بیشتر)
    if (diff > 0.001) {
      for (let i = 0; i < scores.length && diff > 0.001; i++) {
        const type = questions[i].type;
        const step = getStep(type);
        const minScore = getMinScore(type);
        if (scores[i] - step >= minScore - 0.001) {
          const newScore = scores[i] - step;
          const clamped = clampScore(newScore, type);
          const decrease = scores[i] - clamped;
          if (decrease > 0.001) {
            scores[i] = clamped;
            diff -= decrease;
          }
        }
      }
    }
  }

  // ۴. اگر مجموع کمتر از ۲۰ است، اضافه کنیم
  if (sum < 20 - 0.001) {
    // مرتب‌سازی بر اساس نمره (صعودی) و اولویت با سوالاتی که کمترین نمره رو دارن
    let indices = Array.from({ length: questions.length }, (_, i) => i);
    indices.sort((a, b) => scores[a] - scores[b]);

    let diff = 20 - sum;
    for (let idx of indices) {
      if (diff < 0.001) break;
      const type = questions[idx].type;
      const step = getStep(type);
      const maxScore = getMaxScore(type);
      if (scores[idx] + step <= maxScore + 0.001) {
        const newScore = Math.round((scores[idx] + step) / step) * step;
        const clamped = clampScore(newScore, type);
        const increase = clamped - scores[idx];
        if (increase > 0.001) {
          scores[idx] = clamped;
          diff -= increase;
        }
      }
    }
    // اگر همچنان diff مثبت است، به اولین سوالی که امکان افزایش داره اضافه می‌کنیم
    if (diff > 0.001) {
      for (let i = 0; i < scores.length && diff > 0.001; i++) {
        const type = questions[i].type;
        const step = getStep(type);
        const maxScore = getMaxScore(type);
        if (scores[i] + step <= maxScore + 0.001) {
          const newScore = scores[i] + step;
          const clamped = clampScore(newScore, type);
          const increase = clamped - scores[i];
          if (increase > 0.001) {
            scores[i] = clamped;
            diff -= increase;
          }
        }
      }
    }
  }

  // ۵. نهایتاً اگر باز هم اختلاف داشت (به دلیل محدودیت‌ها)، اختلاف را به اولین سوال اضافه/کم می‌کنیم
  // این آخرین مرحله‌ی جبران است — پس سقف نوع را نادیده می‌گیرد تا مجموع قطعاً ۲۰ شود.
  let finalSum = scores.reduce((a, b) => a + b, 0);
  if (Math.abs(finalSum - 20) > 0.001) {
    const diff = 20 - finalSum;
    const firstType = questions[0].type;
    const step = getStep(firstType);
    const minScore = getMinScore(firstType);
    let newScore = Math.round((scores[0] + diff) / step) * step;
    newScore = Math.max(newScore, minScore);
    scores[0] = newScore;
  }

  // ۶. اعمال نمرات به سوالات و برگرداندن
  return questions.map((q, idx) => ({
    ...q,
    score: Math.round(scores[idx] * 100) / 100
  }));
};

// ===== کامپوننت‌های کمکی =====
const SimpleTextEditor = ({ value, onChange, placeholder }) => (
  <textarea
    className="simpleTextarea"
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    rows={4}
  />
);

const MathEditor = ({ value, onChange }) => {
  const [showMath, setShowMath] = useState(false);
  const [latexValue, setLatexValue] = useState(value || '');
  const inputRef = useRef(null);
  const mathSymbols = ['∑', '∫', 'π', '∞', '±', '×', '÷', '≠', '≤', '≥', 'α', 'β', 'γ', 'δ', 'ε', 'θ', 'λ', 'μ', 'σ', 'ω', '∂', '∇', '∆', '∏', '∛', '∜', '⊂', '⊃', '∈', '∉', '∪', '∩', '∅', 'ℕ', 'ℤ', 'ℚ', 'ℝ', 'ℂ', 'sin', 'cos', 'tan', 'log', 'ln', 'lim', '→', '√'];

  const handleSymbolClick = (sym) => {
    const newValue = latexValue + sym;
    setLatexValue(newValue);
    onChange(newValue);
    if (inputRef.current) inputRef.current.focus();
  };

  return (
    <div className="mathEditor">
      <button type="button" className="mathToggle" onClick={() => setShowMath(!showMath)}>
        {showMath ? '🔽 مخفی فرمول' : '➕ فرمول ریاضی'}
      </button>
      {showMath && (
        <div className="mathPanel">
          <div className="mathSymbols">
            {mathSymbols.map(sym => (
              <button key={sym} type="button" className="mathSymbol" onClick={() => handleSymbolClick(sym)}>
                {sym}
              </button>
            ))}
          </div>
          <input
            ref={inputRef}
            type="text"
            className="mathInput"
            value={latexValue}
            onChange={e => { setLatexValue(e.target.value); onChange(e.target.value); }}
            placeholder="فرمول را وارد کنید..."
          />
          <div className="mathPreview">
            <span>پیش‌نمایش: </span>
            <span className="mathPreviewContent">{latexValue || '(خالی)'}</span>
          </div>
        </div>
      )}
    </div>
  );
};

// ===== انتخابگر تاریخ شمسی =====
const PersianDatePicker = ({ value, onChange, placeholder, className }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [tempValue, setTempValue] = useState(value || '');
  const inputRef = useRef(null);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target) &&
        inputRef.current && !inputRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setTempValue(val);
    if (val && moment(val, 'jYYYY-jMM-jDD', true).isValid()) {
      onChange(val);
    } else if (!val) {
      onChange('');
    }
  };

  const handleDateSelect = (day, month, year) => {
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    setTempValue(dateStr);
    onChange(dateStr);
    setShowPicker(false);
  };

  const goToToday = () => {
    const today = moment().format('jYYYY-jMM-jDD');
    setTempValue(today);
    onChange(today);
    setShowPicker(false);
  };

  const goToMonth = (delta) => {
    let currentDate = tempValue || moment().format('jYYYY-jMM-jDD');
    const newDate = moment(currentDate, 'jYYYY-jMM-jDD').add(delta, 'jMonth').format('jYYYY-jMM-jDD');
    setTempValue(newDate);
    onChange(newDate);
  };

  const getDaysInMonth = (jalaliDate) => {
    let m;
    if (jalaliDate && moment(jalaliDate, 'jYYYY-jMM-jDD', true).isValid()) {
      m = moment(jalaliDate, 'jYYYY-jMM-jDD');
    } else {
      m = moment();
    }
    return {
      year: m.jYear(),
      month: m.jMonth() + 1,
      days: m.daysInMonth(),
      firstDayOfWeek: moment(`${m.jYear()}/${m.jMonth() + 1}/1`, 'jYYYY/jMM/jDD').day(),
    };
  };

  const currentDate = tempValue || value || moment().format('jYYYY-jMM-jDD');
  const { year, month, days, firstDayOfWeek } = getDaysInMonth(currentDate);
  const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
  const offset = (firstDayOfWeek + 1) % 7;
  const monthNames = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

  return (
    <div className="persian-datepicker-wrapper">
      <input
        ref={inputRef}
        type="text"
        className={className || 'textInput'}
        value={tempValue}
        onChange={handleInputChange}
        placeholder={placeholder || 'انتخاب تاریخ...'}
        onFocus={() => setShowPicker(true)}
        onClick={() => setShowPicker(true)}
        autoComplete="off"
      />
      {showPicker && (
        <div className="persian-datepicker-popup" ref={pickerRef}>
          <div className="pdp-header">
            <button className="pdp-nav" onClick={() => goToMonth(-1)}>◀</button>
            <span className="pdp-month">{monthNames[month - 1]} {toPersianDigits(year)}</span>
            <button className="pdp-nav" onClick={() => goToMonth(1)}>▶</button>
            <button className="pdp-today" onClick={goToToday} title="امروز">📍</button>
          </div>
          <div className="pdp-weekdays">
            {weekDays.map(d => <span key={d}>{d}</span>)}
          </div>
          <div className="pdp-days">
            {Array.from({ length: offset }, (_, i) => <span key={`empty-${i}`} className="pdp-empty"></span>)}
            {Array.from({ length: days }, (_, i) => {
              const day = i + 1;
              const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
              const isToday = moment().format('jYYYY-jMM-jDD') === dateStr;
              const isSelected = currentDate === dateStr;
              return (
                <span
                  key={day}
                  className={`pdp-day ${isToday ? 'today' : ''} ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleDateSelect(day, month, year)}
                >
                  {toPersianDigits(day)}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

// ===== انتخابگر زمان =====
const TimePicker = ({ value, onChange, placeholder, label, minTime }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [hour, setHour] = useState('');
  const [minute, setMinute] = useState('');
  const [period, setPeriod] = useState('AM');
  const pickerRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (value) {
      const parts = value.split(':');
      if (parts.length === 2) {
        const h = parseInt(parts[0]);
        const m = parseInt(parts[1]);
        setHour(String(h).padStart(2, '0'));
        setMinute(String(m).padStart(2, '0'));
        setPeriod(h >= 12 ? 'PM' : 'AM');
      }
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target) &&
        inputRef.current && !inputRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [minHour, setMinHour] = useState(null);
  const [minMinute, setMinMinute] = useState(null);

  useEffect(() => {
    if (minTime) {
      const parts = minTime.split(':');
      if (parts.length === 2) {
        setMinHour(parseInt(parts[0]));
        setMinMinute(parseInt(parts[1]));
      }
    } else {
      setMinHour(null);
      setMinMinute(null);
    }
  }, [minTime]);

  const handleTimeSelect = (h, m) => {
    let hour24 = h;
    if (period === 'PM' && h !== 12) hour24 = h + 12;
    if (period === 'AM' && h === 12) hour24 = 0;
    const timeStr = `${String(hour24).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    setHour(String(h).padStart(2, '0'));
    setMinute(String(m).padStart(2, '0'));
    onChange(timeStr);
    setShowPicker(false);
  };

  const hours12 = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = Array.from({ length: 60 }, (_, i) => i);
  const currentHour = hour ? parseInt(hour) : 0;
  const currentMinute = minute ? parseInt(minute) : 59;
  const displayHour = currentHour > 12 ? currentHour - 12 : (currentHour === 0 ? 12 : currentHour);

  const displayValue = value ? `${toPersianDigits(displayHour)}:${toPersianDigits(minute || '00')} ${period}` : '';

  return (
    <div className="time-picker-wrapper">
      <input
        ref={inputRef}
        type="text"
        className="textInput time-input"
        value={displayValue}
        placeholder={placeholder || 'ساعت:دقیقه'}
        onFocus={() => setShowPicker(true)}
        onClick={() => setShowPicker(true)}
        readOnly
        autoComplete="off"
      />
      <span className="time-picker-icon" onClick={() => setShowPicker(!showPicker)}></span>
      {showPicker && (
        <div className="time-picker-popup" ref={pickerRef}>
          <div className="time-picker-header">
            <span className="time-picker-label">{label || 'انتخاب زمان'}</span>
            <button className="time-picker-close" onClick={() => setShowPicker(false)}>✕</button>
          </div>
          <div className="time-picker-body">
            <div className="time-picker-column">
              <div className="time-picker-column-header">دقیقه</div>
              <div className="time-picker-scroll">
                {minutes.map(m => {
                  let isDisabled = false;
                  if (minHour !== null && minMinute !== null) {
                    const currentHour24 = currentHour || 0;
                    if (currentHour24 < minHour) isDisabled = true;
                    if (currentHour24 === minHour && m < minMinute) isDisabled = true;
                  }
                  return (
                    <div
                      key={m}
                      className={`time-picker-item ${currentMinute === m ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabled) return;
                        const h = currentHour || 0;
                        const timeStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                        setMinute(String(m).padStart(2, '0'));
                        onChange(timeStr);
                        if (hour && m !== undefined) {
                          setShowPicker(false);
                        }
                      }}
                      style={isDisabled ? { opacity: '0.3', cursor: 'not-allowed' } : {}}
                    >
                      {toPersianDigits(String(m).padStart(2, '0'))}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="time-picker-divider">:</div>
            <div className="time-picker-column">
              <div className="time-picker-column-header">ساعت</div>
              <div className="time-picker-scroll">
                {hours12.map(h => {
                  let h24 = h;
                  if (period === 'PM' && h !== 12) h24 = h + 12;
                  if (period === 'AM' && h === 12) h24 = 0;
                  let isDisabled = false;
                  if (minHour !== null && minMinute !== null) {
                    if (h24 < minHour) isDisabled = true;
                    if (h24 === minHour && parseInt(currentMinute) < minMinute) isDisabled = true;
                    if (h24 === minHour && parseInt(currentMinute) === minMinute) isDisabled = true;
                  }
                  return (
                    <div
                      key={h}
                      className={`time-picker-item ${displayHour === h ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabled) return;
                        let h24 = h;
                        if (period === 'PM' && h !== 12) h24 = h + 12;
                        if (period === 'AM' && h === 12) h24 = 0;
                        const timeStr = `${String(h24).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;
                        setHour(String(h24).padStart(2, '0'));
                        onChange(timeStr);
                      }}
                      style={isDisabled ? { opacity: '0.3', cursor: 'not-allowed' } : {}}
                    >
                      {toPersianDigits(String(h).padStart(2, '0'))}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="time-picker-period">
              <button
                className={`time-picker-period-btn ${period === 'AM' ? 'active' : ''}`}
                onClick={() => {
                  setPeriod('AM');
                  if (hour) {
                    let h = parseInt(hour);
                    if (h >= 12) h = h - 12;
                    const timeStr = `${String(h).padStart(2, '0')}:${minute || '00'}`;
                    onChange(timeStr);
                  }
                }}
              >
                قبل از ظهر
              </button>
              <button
                className={`time-picker-period-btn ${period === 'PM' ? 'active' : ''}`}
                onClick={() => {
                  setPeriod('PM');
                  if (hour) {
                    let h = parseInt(hour);
                    if (h < 12) h = h + 12;
                    const timeStr = `${String(h).padStart(2, '0')}:${minute || '00'}`;
                    onChange(timeStr);
                  }
                }}
              >
                بعد از ظهر
              </button>
            </div>
          </div>
          <div className="time-picker-footer">
            <button className="time-picker-now" onClick={() => {
              const now = moment();
              const h = now.format('HH');
              const m = now.format('mm');
              setHour(h);
              setMinute(m);
              setPeriod(parseInt(h) >= 12 ? 'PM' : 'AM');
              onChange(`${h}:${m}`);
              setShowPicker(false);
            }}>
              ⏰ اکنون
            </button>
            <button className="time-picker-clear" onClick={() => {
              setHour('');
              setMinute('');
              setPeriod('AM');
              onChange('');
              setShowPicker(false);
            }}>
              ✕ پاک کردن
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================================
// ===== کامپوننت اصلی =====
// ============================================================
const CreateExamAI = ({ __stepQuizContext = null }) => {   // 🆕
  const navigate = useNavigate();
  const { examId } = useParams();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');

  // 🆕 Step Quiz Mode
  const isStepQuizMode = !!__stepQuizContext;
  const stepQuizInitialData = __stepQuizContext?.initialData || null;
  const stepQuizOnSave = __stepQuizContext?.onSave || null;
  const stepQuizOnCancel = __stepQuizContext?.onCancel || null;
  const stepQuizOnSuccess = __stepQuizContext?.onSuccess || null;

  const { exams, addExam, updateExam, getExam, getTeamTotalStudents } = useExams();

  const { user } = useAuth();
  const currentTeacherId = user?.id || null;
  const isAdmin = isGlobalAdmin(currentTeacherId);

  const [teacherTeamId, setTeacherTeamId] = useState(null);
  const [teamTotalStudents, setTeamTotalStudents] = useState(0);

  useEffect(() => {
    let foundTeamId = null;
    const storedTeam = localStorage.getItem('team');
    if (storedTeam) {
      try { const team = JSON.parse(storedTeam); if (team && team.id) foundTeamId = team.id; } catch { /* ignore */ }
    }
    if (!foundTeamId) {
      const storedMembers = localStorage.getItem('teamMembers');
      if (storedMembers) {
        try {
          const parsed = JSON.parse(storedMembers);
          const teacherMember = parsed.find(m => m.studentId === currentTeacherId && m.status === 'active');
          if (teacherMember) foundTeamId = teacherMember.teamId;
        } catch { /* ignore */ }
      }
    }
    setTeacherTeamId(foundTeamId);
    if (foundTeamId && foundTeamId !== 'no-group') setTeamTotalStudents(getTeamTotalStudents(foundTeamId));
  }, [currentTeacherId, getTeamTotalStudents]);

  // 🆕 بارگذاری سهمیه و اشتراک AI
  const refreshAIQuota = useCallback(async () => {
    if (!currentTeacherId) return;
    setAiQuotaLoading(true);
    try {
      const [q, s] = await Promise.all([
        getAIQuota(currentTeacherId),
        getAISubscription(currentTeacherId),
      ]);
      setAiQuota(q);
      setAiSubscription(s);
    } catch (e) {
      console.warn('refreshAIQuota failed', e);
    } finally {
      setAiQuotaLoading(false);
    }
  }, [currentTeacherId]);

  useEffect(() => { refreshAIQuota(); }, [refreshAIQuota]);

  useEffect(() => {
    if (!currentTeacherId) return;
    const t = setInterval(refreshAIQuota, 60000);
    return () => clearInterval(t);
  }, [currentTeacherId, refreshAIQuota]);

  useEffect(() => {
    const onFocus = () => refreshAIQuota();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refreshAIQuota]);



  const existingExam = examId ? getExam(examId) : null;
  const isEditing = !!existingExam;

  // ===== Stateهای اصلی =====
  const [examInfo, setExamInfo] = useState({
    title: '',
    description: '',
    book: '',
    class: '',
    date: moment().format('jYYYY-jMM-jDD'),
    duration: '',
    shuffleQuestions: false,
    shuffleOptions: false,
    showResult: true,
    showCorrectAnswers: true,
    limitAttempts: 1,
    displayMode: 'step',
    startTime: '',
    endTime: '',
    image: null,
    ipRestriction: '',
    teamId: null,
    teacherId: currentTeacherId,
    totalStudents: 0,
    isGlobal: false,
    grade: '',
    field: null,        // 🔽 CHANGED
    fieldTitle: '',     // 🔽 CHANGED
    subject: '',
    chapter: '',
    _gregorianDate: '',
    isChallenge: false,
    isDailyChallenge: false,
    coinsExcellent: 0,
    xpExcellent: 0,
    coinsVeryGood: 0,
    xpVeryGood: 0,
    coinsGood: 0,
    xpGood: 0,
    coinsNeedsWork: 0,
    xpNeedsWork: 0,
    coinsUnacceptable: 0,
    xpUnacceptable: 0,
    coinsFailed: 0,
    xpFailed: 0,
    // 🆕 badge controls (admin only)
    requiredCoins: 0,
    forceNew: false,
    forceHot: false,
    newBadgeDuration: 24,
    hotThresholdParticipants: 1000,
    hotThresholdRecentResults: 100,
  });

  // ===== Stateهای فیلدهای آبشاری =====
  const [availableBooks, setAvailableBooks] = useState([]);
  const [availableChapters, setAvailableChapters] = useState([]);
  const [availableLessons, setAvailableLessons] = useState([]);
  const [availableFields, setAvailableFields] = useState([]);   // 🔽 CHANGED
  const [customGrade, setCustomGrade] = useState('');
  const [customBook, setCustomBook] = useState('');
  const [customChapter, setCustomChapter] = useState('');
  const [customSubject, setCustomSubject] = useState('');
  const [customGradeConfirmed, setCustomGradeConfirmed] = useState(false);
  const [customBookConfirmed, setCustomBookConfirmed] = useState(false);
  const [customChapterConfirmed, setCustomChapterConfirmed] = useState(false);
  const [customSubjectConfirmed, setCustomSubjectConfirmed] = useState(false);

  // ===== Stateهای سوالات =====
  const [questions, setQuestions] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 🆕 باز/بسته بودن بخش تنظیمات پیشرفته (پیش‌فرض: بسته)
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [isUploadingExamImage, setIsUploadingExamImage] = useState(false);

  // ===== Stateهای مربوط به AI =====
  const [aiConfig, setAiConfig] = useState({
    difficulty: 3,
    numMultiple: 5,
    numEssay: 0,
    numFill: 0,
    numMatching: 0,
    numOrdering: 0,
    numTrueFalse: 0,
    numMulti: 0,
  });
  const [isGenerating, setIsGenerating] = useState(false);
  const [generationProgress, setGenerationProgress] = useState(0);
  const [generationError, setGenerationError] = useState(null);

  // 🆕 Stateهای سهمیه و اشتراک AI
  const [aiQuota, setAiQuota] = useState(null);
  const [aiSubscription, setAiSubscription] = useState(null);
  const [aiQuotaLoading, setAiQuotaLoading] = useState(true);
  const [showSubModal, setShowSubModal] = useState(false);
  const [subLoading, setSubLoading] = useState(null);
  const generatingLockRef = useRef(false);








  // 🆕 کلید draft
  const DRAFT_KEY = (!currentTeacherId || isStepQuizMode)
    ? null
    : (examId
        ? `exam-draft-v1-${currentTeacherId}-${examId}`
        : `exam-draft-v1-${currentTeacherId}-new`);

    // 🌗 state تم تیره
const [isDarkMode, setIsDarkMode] = useState(() => {
  try {
    return localStorage.getItem('navbar2-drawer-dark') === '1';
  } catch {
    return false;
  }
});

const toggleTheme = () => setIsDarkMode((prev) => !prev);

// ذخیره در کلید مشترک Navbar2
useEffect(() => {
  try {
    localStorage.setItem('navbar2-drawer-dark', isDarkMode ? '1' : '0');
  } catch {}
}, [isDarkMode]);

// گوش دادن به تغییرات Navbar2
useEffect(() => {
  const handleStorage = (e) => {
    if (e.key === 'navbar2-drawer-dark') {
      setIsDarkMode(e.newValue === '1');
    }
  };
  window.addEventListener('storage', handleStorage);

  const interval = setInterval(() => {
    try {
      const current = localStorage.getItem('navbar2-drawer-dark') === '1';
      setIsDarkMode((prev) => (prev !== current ? current : prev));
    } catch {}
  }, 500);

  return () => {
    window.removeEventListener('storage', handleStorage);
    clearInterval(interval);
  };
}, []);

// ✅ حل مشکل ورودی‌های عددی در موبایل — انتخاب خودکار متن هنگام فوکوس
useEffect(() => {
  const handleFocusIn = (e) => {
    const input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'number') return;

    // ترفند: تغییر موقت type به text تا select() روی موبایل کار کنه
    const originalType = input.type;
    input.type = 'text';
    input.select();
    input.type = originalType;
  };

  document.addEventListener('focusin', handleFocusIn, true);
  return () => document.removeEventListener('focusin', handleFocusIn, true);
}, []);



  // ===== Ref برای PDF =====
  const pdfContentRef = useRef(null);
  const addQuestionAreaRef = useRef(null);

  // ===== محاسبه مجموع نمرات =====
  const totalScore = useMemo(() => {
    return questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
  }, [questions]);

  const isTotalScoreValid = Math.abs(totalScore - 20) < 0.01;
  const isTotalScoreExceeded = totalScore > 20 + 0.01;
  const canAddQuestion = !isTotalScoreExceeded;

  // 🆕 مقداردهی از initialData در Step Quiz Mode
  useEffect(() => {
    if (!isStepQuizMode || !stepQuizInitialData) return;
    setExamInfo((prev) => ({
      ...prev,
      ...stepQuizInitialData,
      isGlobal: false,
      isChallenge: false,
      isDailyChallenge: false,
      teamId: null,
    }));
    if (Array.isArray(stepQuizInitialData.questions)) {
      setQuestions(stepQuizInitialData.questions);
    }
  }, [isStepQuizMode, stepQuizInitialData]);

  // ===== بارگذاری داده‌های آزمون در حالت ویرایش =====
  useEffect(() => {
    if (existingExam) {
      let examDate = existingExam.date || moment().format('jYYYY-jMM-jDD');
      let startTime = existingExam.startTime || '';
      let endTime = existingExam.endTime || '';

      if (examDate && examDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        try {
          const m = moment(examDate, 'YYYY-MM-DD');
          if (m.isValid()) examDate = m.format('jYYYY-jMM-jDD');
        } catch (e) {}
      }

      if (startTime && startTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
        try {
          const m = moment(startTime);
          if (m.isValid()) {
            startTime = m.format('HH:mm');
          }
        } catch (e) {}
      } else if (startTime && startTime.match(/^\d{2}:\d{2}$/)) {
        startTime = startTime;
      } else {
        startTime = '';
      }

      if (endTime && endTime.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
        try {
          const m = moment(endTime);
          if (m.isValid()) {
            endTime = m.format('HH:mm');
          }
        } catch (e) {}
      } else if (endTime && endTime.match(/^\d{2}:\d{2}$/)) {
        endTime = endTime;
      } else {
        endTime = '';
      }

      // ===== 🔽 CHANGED: تشخیص مقادیر سفارشی (سایر) قبل از بارگذاری =====
      const existingGrade = existingExam.grade || '';
      const existingFieldRaw = existingExam.field;
      const existingField = existingFieldRaw ? (curriculumNormalizeField(existingFieldRaw) || null) : null;
      const existingFieldTitle = existingExam.fieldTitle
        || (existingField ? (getFieldMeta(existingField)?.title || '') : '');
      const existingBook = existingExam.book || '';
      const existingChapter = existingExam.chapter || '';
      const existingSubject = existingExam.subject || '';

      const gradeIsCustom = !!existingGrade && !gradeOptions.includes(existingGrade);

      let defaultBookList = [];
      let defaultChapterList = [];
      let defaultLessonList = [];
      const detectGradeData = (!gradeIsCustom && existingGrade) ? curriculumData[existingGrade] : null;

      if (detectGradeData) {
        const needsFieldHere = curriculumNeedsField(existingGrade);
        if (needsFieldHere && detectGradeData.fields && existingFieldTitle && detectGradeData.fields[existingFieldTitle]) {
          const fd = detectGradeData.fields[existingFieldTitle];
          defaultBookList = Object.keys(fd.books);
          if (existingBook && defaultBookList.includes(existingBook)) {
            const bd = fd.books[existingBook];
            defaultChapterList = bd.chapters || [];
            defaultLessonList = bd.lessons || [];
          }
        } else if (!needsFieldHere && detectGradeData.books) {
          defaultBookList = Object.keys(detectGradeData.books);
          if (existingBook && defaultBookList.includes(existingBook)) {
            const bd = detectGradeData.books[existingBook];
            defaultChapterList = bd.chapters || [];
            defaultLessonList = bd.lessons || [];
          }
        }
      }

      const bookIsCustom = !!existingBook && !defaultBookList.includes(existingBook);
      const chapterIsCustom = !!existingChapter && !defaultChapterList.includes(existingChapter);
      const lessonIsCustom = !!existingSubject && !defaultLessonList.includes(existingSubject);

      if (gradeIsCustom) {
        setCustomGrade(existingGrade);
        setCustomGradeConfirmed(true);
      }
      if (bookIsCustom) {
        setCustomBook(existingBook);
        setCustomBookConfirmed(true);
      }
      if (chapterIsCustom) {
        setCustomChapter(existingChapter);
        setCustomChapterConfirmed(true);
      }
      if (lessonIsCustom) {
        setCustomSubject(existingSubject);
        setCustomSubjectConfirmed(true);
      }

      setExamInfo({
        ...existingExam,
        grade: gradeIsCustom ? 'سایر' : existingGrade,
        book: bookIsCustom ? 'سایر' : existingBook,
        chapter: chapterIsCustom ? 'سایر' : existingChapter,
        subject: lessonIsCustom ? 'سایر' : existingSubject,
        date: examDate,
        startTime: startTime,
        endTime: endTime,
        _gregorianDate: existingExam._gregorianDate || '',
        teacherId: existingExam.teacherId || currentTeacherId,
        teamId: existingExam.teamId || teacherTeamId,
        totalStudents: existingExam.totalStudents || teamTotalStudents || 0,
        // 🔽 CHANGED: نرمال‌سازی field
        field: existingExam.field ? (curriculumNormalizeField(existingExam.field) || null) : null,
        fieldTitle: existingExam.fieldTitle
          || (existingExam.field
            ? (getFieldMeta(curriculumNormalizeField(existingExam.field))?.title || '')
            : ''),
      });
      setQuestions(existingExam.questions || []);

      // 🔽 CHANGED: مقداردهی لیست‌های آبشاری با پشتیبانی از رشته
      if (existingExam.grade && curriculumData[existingExam.grade]) {
        const gradeData = curriculumData[existingExam.grade];
        const gradeNeedsFieldHere = curriculumNeedsField(existingExam.grade);

        if (gradeNeedsFieldHere && gradeData.fields) {
          const fieldTitles = Object.keys(gradeData.fields);
          setAvailableFields(fieldTitles);

          const storedField = existingExam.field
            ? (curriculumNormalizeField(existingExam.field) || null)
            : null;
          const fieldTitle = storedField
            ? (getFieldMeta(storedField)?.title || '')
            : (existingExam.fieldTitle || '');

          if (fieldTitle && gradeData.fields[fieldTitle]) {
            const books = Object.keys(gradeData.fields[fieldTitle].books);
            setAvailableBooks(books);
            if (existingExam.book && books.includes(existingExam.book)) {
              const bookData = gradeData.fields[fieldTitle].books[existingExam.book];
              setAvailableChapters(bookData.chapters || []);
              setAvailableLessons(bookData.lessons || []);
            }
          }
        } else if (gradeData.books) {
          const books = Object.keys(gradeData.books);
          setAvailableBooks(books);
          if (existingExam.book && books.includes(existingExam.book)) {
            const bookData = gradeData.books[existingExam.book];
            setAvailableChapters(bookData.chapters || []);
            if (existingExam.chapter && bookData.chapters?.includes(existingExam.chapter)) {
              setAvailableLessons(bookData.lessons || []);
            }
          }
        }
      }
    } else {
      // 🆕 حذف شرط isAdmin: چون mode فقط از دکمه‌های ادمین ست می‌شود،
      //    و addExam در ExamContext خودش isAdmin را چک می‌کند.
      if (mode === 'global') {
        setExamInfo(prev => ({ ...prev, isGlobal: true, isChallenge: false }));
      } else if (mode === 'challenge') {
        setExamInfo(prev => ({ ...prev, isGlobal: true, isChallenge: true }));
      } else {
        setExamInfo(prev => ({ ...prev, isGlobal: false, isChallenge: false }));
      }
    }
  }, [existingExam, teacherTeamId, currentTeacherId, teamTotalStudents, mode, isAdmin]);






    // 🆕 بازیابی state پس از بازگشت از PDF (شامل aiConfig)
  useEffect(() => {
    try {
      const raw = localStorage.getItem('exam-pdf-backup');
      if (!raw) return;
      localStorage.removeItem('exam-pdf-backup');
      const d = JSON.parse(raw);
      if (!d || (!d.examInfo?.title && !d.questions?.length)) return;
      setExamInfo(prev => ({ ...prev, ...d.examInfo }));
      setQuestions(Array.isArray(d.questions) ? d.questions : []);
      if (d.aiConfig) setAiConfig(d.aiConfig);
      setCustomGrade(d.customGrade || '');
      setCustomBook(d.customBook || '');
      setCustomChapter(d.customChapter || '');
      setCustomSubject(d.customSubject || '');
      setCustomGradeConfirmed(!!d.customGradeConfirmed);
      setCustomBookConfirmed(!!d.customBookConfirmed);
      setCustomChapterConfirmed(!!d.customChapterConfirmed);
      setCustomSubjectConfirmed(!!d.customSubjectConfirmed);
    } catch {}

  }, []);


    // 🆕 ذخیره‌ی خودکار — با aiConfig
  useEffect(() => {
    if (!DRAFT_KEY) return;
    if (!examInfo.title && !examInfo.book && !questions.length) {
      try { localStorage.removeItem(DRAFT_KEY); } catch {}
      return;
    }
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify({
        examInfo, questions, aiConfig,
        customGrade, customBook, customChapter, customSubject,
        customGradeConfirmed, customBookConfirmed,
        customChapterConfirmed, customSubjectConfirmed,
      }));
    } catch {}
  }, [
    DRAFT_KEY, examInfo, questions, aiConfig,
    customGrade, customBook, customChapter, customSubject,
    customGradeConfirmed, customBookConfirmed,
    customChapterConfirmed, customSubjectConfirmed,
  ]);



    // 🆕 بازیابی روی mount
  const draftLoadedRef = useRef(false);
  useEffect(() => {
    if (!DRAFT_KEY || draftLoadedRef.current) return;
    draftLoadedRef.current = true;
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return;
      const d = JSON.parse(raw);
      if (!d || (!d.examInfo?.title && !d.questions?.length)) return;

      // 🆕 اگر mode در URL هست، فیلدهای نوع را از draft نگیر
      const restoredExamInfo = { ...d.examInfo };
      if (mode) {
        delete restoredExamInfo.isGlobal;
        delete restoredExamInfo.isChallenge;
        delete restoredExamInfo.isDailyChallenge;
        delete restoredExamInfo.teamId;
      }

      setExamInfo(prev => ({ ...prev, ...restoredExamInfo }));
      setQuestions(Array.isArray(d.questions) ? d.questions : []);
      if (d.aiConfig) setAiConfig(d.aiConfig);
      setCustomGrade(d.customGrade || '');
      setCustomBook(d.customBook || '');
      setCustomChapter(d.customChapter || '');
      setCustomSubject(d.customSubject || '');
      setCustomGradeConfirmed(!!d.customGradeConfirmed);
      setCustomBookConfirmed(!!d.customBookConfirmed);
      setCustomChapterConfirmed(!!d.customChapterConfirmed);
      setCustomSubjectConfirmed(!!d.customSubjectConfirmed);
    } catch {}
  }, [DRAFT_KEY, mode]);


  // 🔽 CHANGED: به‌روزرسانی لیست‌های آبشاری با پشتیبانی از رشته

  // پایه → رشته‌ها + کتاب‌ها
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;

    if (gradeData?.fields) {
      const fieldTitles = Object.keys(gradeData.fields);
      setAvailableFields(fieldTitles);

      if (examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
        const books = Object.keys(gradeData.fields[examInfo.fieldTitle].books);
        setAvailableBooks(books);
        if (!books.includes(examInfo.book) && examInfo.book !== 'سایر') {
          setExamInfo((prev) => ({ ...prev, book: '', chapter: '', subject: '' }));
          setAvailableChapters([]);
          setAvailableLessons([]);
        }
      } else {
        setAvailableBooks([]);
        setAvailableChapters([]);
        setAvailableLessons([]);
      }
    } else if (gradeData?.books) {
      setAvailableFields([]);
      const books = Object.keys(gradeData.books);
      setAvailableBooks(books);
      if (!books.includes(examInfo.book) && examInfo.book !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, book: '', chapter: '', subject: '' }));
        setAvailableChapters([]);
        setAvailableLessons([]);
      }
    } else {
      setAvailableFields([]);
      setAvailableBooks([]);
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle]);

  // کتاب → فصل‌ها
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;
    let bookData = null;

    if (gradeData?.fields && examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
      bookData = gradeData.fields[examInfo.fieldTitle].books[examInfo.book];
    } else if (gradeData?.books) {
      bookData = gradeData.books[examInfo.book];
    }

    if (bookData) {
      const chapters = bookData.chapters || [];
      setAvailableChapters(chapters);
      if (!chapters.includes(examInfo.chapter) && examInfo.chapter !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, chapter: '', subject: '' }));
        setAvailableLessons([]);
      }
    } else {
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle, examInfo.book]);

  // فصل → درس‌ها
  useEffect(() => {
    const gradeData = examInfo.grade ? curriculumData[examInfo.grade] : null;
    let bookData = null;

    if (gradeData?.fields && examInfo.fieldTitle && gradeData.fields[examInfo.fieldTitle]) {
      bookData = gradeData.fields[examInfo.fieldTitle].books[examInfo.book];
    } else if (gradeData?.books) {
      bookData = gradeData.books[examInfo.book];
    }

    if (bookData && examInfo.chapter) {
      const lessons = bookData.lessons || [];
      setAvailableLessons(lessons);
      if (!lessons.includes(examInfo.subject) && examInfo.subject !== 'سایر') {
        setExamInfo((prev) => ({ ...prev, subject: '' }));
      }
    } else {
      setAvailableLessons([]);
    }
  }, [examInfo.grade, examInfo.fieldTitle, examInfo.book, examInfo.chapter]);

  // ===== هندلرهای تغییرات =====
  const handleExamInfoChange = (e) => {
    const { name, value, type, checked } = e.target;
    setExamInfo(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

const handleExamImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  if (file.size > 2 * 1024 * 1024) {
    alert('حجم تصویر نباید بیشتر از ۲ مگابایت باشد');
    e.target.value = '';
    return;
  }

  const oldImage = examInfo.image;
  setIsUploadingExamImage(true);

  try {
    const path = await uploadImage(file, currentTeacherId, null, 'cover');
    setExamInfo(prev => ({ ...prev, image: path }));

    if (oldImage) {
      try {
        await deleteImage(oldImage);
      } catch (cleanupErr) {
        console.warn('حذف تصویر قبلی ناموفق بود:', cleanupErr);
      }
    }
  } catch (error) {
    alert('خطا در آپلود تصویر: ' + error.message);
  } finally {
    setIsUploadingExamImage(false);
  }
};

  const handleDateChange = (value) => {
    if (value) {
      try {
        const gregorianDate = moment(value, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
        setExamInfo(prev => ({ ...prev, date: value, _gregorianDate: gregorianDate }));
      } catch (e) {
        setExamInfo(prev => ({ ...prev, date: value, _gregorianDate: '' }));
      }
    } else {
      setExamInfo(prev => ({ ...prev, date: '', _gregorianDate: '' }));
    }
  };

  const handleStartTimeChange = (value) => {
    setExamInfo(prev => ({ ...prev, startTime: value }));
  };

  const handleEndTimeChange = (value) => {
    setExamInfo(prev => ({ ...prev, endTime: value }));
  };

  const handleGradeChange = (value) => {
    // 🔽 CHANGED: ریست field + fieldTitle
    setExamInfo((prev) => ({
      ...prev,
      grade: value,
      field: null,
      fieldTitle: '',
      book: '',
      chapter: '',
      subject: '',
    }));
    setCustomGradeConfirmed(false);
    setAvailableFields([]);
    if (value === 'سایر') {
      setCustomGrade('');
      setAvailableBooks([]);
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  };

  // 🔽 CHANGED: هندلر جدید رشته
  const handleFieldChange = (value) => {
    const fieldMeta = value ? getFieldMeta(value) : null;
    setExamInfo((prev) => ({
      ...prev,
      field: value || null,
      fieldTitle: fieldMeta?.title || '',
      book: '',
      chapter: '',
      subject: '',
    }));
  };

  const handleBookChange = (value) => {
    setExamInfo(prev => ({ ...prev, book: value, chapter: '', subject: '' }));
    setCustomBookConfirmed(false);
    if (value === 'سایر') {
      setCustomBook('');
      setAvailableChapters([]);
      setAvailableLessons([]);
    }
  };

  const handleChapterChange = (value) => {
    setExamInfo(prev => ({ ...prev, chapter: value, subject: '' }));
    setCustomChapterConfirmed(false);
    if (value === 'سایر') {
      setCustomChapter('');
      setAvailableLessons([]);
    }
  };

  const handleSubjectChange = (value) => {
    setExamInfo(prev => ({ ...prev, subject: value }));
    setCustomSubjectConfirmed(false);
    if (value === 'سایر') {
      setCustomSubject('');
    }
  };

  // ===== هندلرهای مدیریت سوالات =====
  const editQuestion = (id) => {
    const q = questions.find(q => q.id === id);
    if (q) {
      alert('برای ویرایش سوالات تولید شده با AI لطفا ابتدا آزمون را ذخیره موقت کنید و بعدش دوباره به حالت ویرایش وارد شوید');
    }
  };

  const removeQuestion = async (id) => {
    const msg = 'آیا از حذف این سوال مطمئن هستید؟';
    const ok = typeof window.askConfirm === 'function'
      ? await window.askConfirm(msg)
      : window.confirm(msg);
    if (ok) {
      setQuestions(questions.filter(q => q.id !== id));
    }
  };

  const duplicateQuestion = (id) => {
    const q = questions.find(q => q.id === id);
    if (q) {
      const newScore = toNumber(q.score, 0);
      if (totalScore + newScore > 20 + 0.01) {
        alert(`⚠️ با کپی کردن این سوال مجموع نمرات از ۲۰ بیشتر می‌شود.\nمجموع فعلی: ${totalScore.toFixed(2)} از ۲۰`);
        return;
      }
      setQuestions([...questions, { ...q, id: Date.now().toString(36) + Math.random().toString(36).substring(2, 9), question: q.question + ' (کپی)' }]);
    }
  };

  const moveQuestion = (index, direction) => {
    const newQuestions = [...questions];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= questions.length) return;
    [newQuestions[index], newQuestions[targetIndex]] = [newQuestions[targetIndex], newQuestions[index]];
    setQuestions(newQuestions);
  };

  // ===== اعتبارسنجی فرم =====
  const validateExam = () => {
    const newErrors = {};

    // 🆕 در Step Quiz Mode فقط فیلدهای مرتبط با آزمون مرحله چک می‌شن
    if (isStepQuizMode) {
      if (!examInfo.title?.trim()) {
        newErrors.title = 'عنوان آزمون الزامی است';
      }
      if (!examInfo.duration || toNumber(examInfo.duration) <= 0) {
        newErrors.duration = 'مدت زمان آزمون الزامی است';
      }
      if (questions.length === 0) {
        newErrors.questions = 'حداقل یک سوال اضافه کنید';
      } else {
        const totalScoreCalc = questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
        if (Math.abs(totalScoreCalc - 20) > 0.01) {
          newErrors.totalScore = `مجموع نمرات باید دقیقاً ۲۰ باشد (در حال حاضر ${totalScoreCalc.toFixed(2)})`;
        }
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }

    // ===== جریان عادی (آزمون گروهی / عمومی / چالش) =====
    if (!examInfo.title.trim()) newErrors.title = 'عنوان آزمون الزامی است';
    if (examInfo.book === 'سایر') {
      if (!customBook.trim()) newErrors.book = 'لطفاً نام کتاب را وارد کنید';
    } else if (!examInfo.book.trim()) {
      newErrors.book = 'کتاب الزامی است';
    }
    if (!examInfo.isGlobal && !examInfo.date.trim()) newErrors.date = 'تاریخ برگزاری الزامی است';
    if (examInfo.grade === 'سایر') {
      if (!customGrade.trim()) newErrors.grade = 'لطفاً نام پایه را وارد کنید';
    } else if (!examInfo.grade.trim()) {
      newErrors.grade = 'پایه تحصیلی الزامی است';
    }

    // 🔽 CHANGED: اعتبارسنجی رشته
    if (examInfo.grade && curriculumNeedsField(examInfo.grade)) {
      if (!examInfo.field) {
        newErrors.field = 'انتخاب رشته برای پایه‌های متوسطه دوم الزامی است';
      }
    }

    if (!examInfo.duration || toNumber(examInfo.duration) <= 0) newErrors.duration = 'مدت زمان آزمون الزامی است';

    if (examInfo.isGlobal) {
      if (examInfo.grade === 'سایر') {
        if (!customGrade.trim()) newErrors.grade = 'لطفاً نام پایه را وارد کنید';
      } else if (!examInfo.grade.trim()) {
        newErrors.grade = 'پایه تحصیلی برای آزمون عمومی الزامی است';
      }
      // if (examInfo.subject === 'سایر') {
      //   if (!customSubject.trim()) newErrors.subject = 'لطفاً نام درس را وارد کنید';
      // } else if (!examInfo.subject.trim()) {
      //   newErrors.subject = 'درس برای آزمون عمومی الزامی است';
      // }
      if (examInfo.chapter === 'سایر') {
        if (!customChapter.trim()) newErrors.chapter = 'لطفاً نام فصل را وارد کنید';
      } else if (!examInfo.chapter.trim()) {
        newErrors.chapter = 'فصل برای آزمون عمومی الزامی است';
      }
    }

    if (questions.length === 0) {
      newErrors.questions = 'حداقل یک سوال اضافه کنید';
    } else {
      const totalScoreCalc = questions.reduce((sum, q) => sum + toNumber(q.score, 0), 0);
      if (Math.abs(totalScoreCalc - 20) > 0.01) {
        newErrors.totalScore = `مجموع نمرات باید دقیقاً ۲۰ باشد (در حال حاضر ${totalScoreCalc.toFixed(2)})`;
      }
    }

    if (examInfo.startTime && examInfo.endTime) {
      if (examInfo.startTime >= examInfo.endTime) {
        newErrors.timeRange = 'زمان شروع باید قبل از زمان پایان باشد';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ===== تولید سوالات با هوش مصنوعی (نسخه نهایی) =====
  const generateQuestionsWithAI = async () => {
    // اعتبارسنجی اولیه
    if (!examInfo.grade || !examInfo.book ) {
      alert('لطفاً ابتدا پایه و کتاب را به‌درستی انتخاب کنید.');
      return;
    }
    if (examInfo.grade === 'سایر' && !customGradeConfirmed) {
      alert('لطفاً مقدار پایه را تأیید کنید.');
      return;
    }
    if (examInfo.book === 'سایر' && !customBookConfirmed) {
      alert('لطفاً مقدار کتاب را تأیید کنید.');
      return;
    }
    if (examInfo.chapter === 'سایر' && !customChapterConfirmed) {
      alert('لطفاً مقدار فصل را تأیید کنید.');
      return;
    }
    if (examInfo.subject === 'سایر' && !customSubjectConfirmed) {
      alert('لطفاً مقدار درس را تأیید کنید.');
      return;
    }

    const totalAiQuestions = aiConfig.numMultiple + aiConfig.numEssay + aiConfig.numFill +
                             aiConfig.numMatching + aiConfig.numOrdering + aiConfig.numTrueFalse + aiConfig.numMulti;
    if (totalAiQuestions === 0) {
      alert('لطفاً حداقل یک سوال برای تولید انتخاب کنید.');
      return;
    }

    if (!navigator.onLine) {
      alert('⚠️ اتصال اینترنت خود را بررسی کنید و دوباره تلاش نمایید.');
      setGenerationError('اتصال اینترنت خود را بررسی کنید');
      return;
    }

    // ============================================================
    // 🆕 بررسی سهمیه AI (Backend-Sync)
    // ============================================================
    if (generatingLockRef.current) {
      alert('⏳ یک درخواست در حال انجام است...');
      return;
    }
    generatingLockRef.current = true;

    let quotaConsumed = false;
    try {
      const quotaCheck = await canGenerateAI(currentTeacherId);
      if (!quotaCheck.allowed) {
        generatingLockRef.current = false;
        setShowSubModal(true);
        return;
      }

      const consumeResult = await consumeAIQuota(currentTeacherId);
      if (!consumeResult.ok) {
        generatingLockRef.current = false;
        setShowSubModal(true);
        return;
      }

      quotaConsumed = true;
      setAiQuota(consumeResult.quota);
      setAiSubscription(await getAISubscription(currentTeacherId));
    } catch (e) {
      generatingLockRef.current = false;
      console.error('Quota check failed:', e);
      alert('خطا در بررسی سهمیه. لطفاً دوباره تلاش کنید.');
      return;
    }
    // ============================================================

    setIsGenerating(true);
    setGenerationProgress(0);
    setGenerationError(null);

    const grade = examInfo.grade === 'سایر' ? customGrade : examInfo.grade;
    const book = examInfo.book === 'سایر' ? customBook : examInfo.book;
    const chapter = examInfo.chapter === 'سایر' ? customChapter : examInfo.chapter;
    const subject = examInfo.subject === 'سایر' ? customSubject : examInfo.subject;
    const difficulty = aiConfig.difficulty;

    const difficultyLabels = {
      1: 'خیلی آسان (سوالات پایه و سطح ابتدایی)',
      2: 'آسان (سوالات متوسط رو به پایین)',
      3: 'متوسط (سوالات استاندارد و متنوع)',
      4: 'سخت (سوالات چالش‌برانگیز)',
      5: 'خیلی سخت (سوالات پیشرفته و ترکیبی)'
    };

    const buildTypeDescription = () => {
      const parts = [];
      if (aiConfig.numMultiple > 0) parts.push(`تستی تک‌انتخابی: ${aiConfig.numMultiple} سوال`);
      if (aiConfig.numMulti > 0) parts.push(`تستی چندانتخابی: ${aiConfig.numMulti} سوال`);
      if (aiConfig.numTrueFalse > 0) parts.push(`صحیح/غلط: ${aiConfig.numTrueFalse} سوال`);
      if (aiConfig.numFill > 0) parts.push(`جای خالی: ${aiConfig.numFill} سوال`);
      if (aiConfig.numEssay > 0) parts.push(`تشریحی: ${aiConfig.numEssay} سوال`);
      if (aiConfig.numMatching > 0) parts.push(`تطبیقی: ${aiConfig.numMatching} سوال`);
      if (aiConfig.numOrdering > 0) parts.push(`مرتب‌سازی: ${aiConfig.numOrdering} سوال`);
      return parts.join('، ');
    };

    const prompt = `
      شما یک دستیار هوشمند برای تولید سوالات آزمون هستید.
      لطفاً بر اساس اطلاعات زیر، سوالات آزمون را تولید کنید.

      اطلاعات پایه:
      - پایه تحصیلی: ${grade}
      - کتاب: ${book}
      - فصل: ${chapter}
      - درس: ${subject}
      - سطح دشواری: ${difficultyLabels[difficulty]}

      تعداد سوالات به تفکیک نوع:
      ${buildTypeDescription()}

      قوانین مهم:
      1. هر سوال باید دقیقاً با نوع مشخص شده مطابقت داشته باشد.
      2. تعداد سوالات هر نوع باید دقیقاً برابر با عدد مشخص شده باشد.
      3. سوالات باید کاملاً مرتبط با کتاب درسی ایران (پایه ${grade}) و فصل ${chapter} از کتاب ${book} باشند.
      4. سوالات باید متنوع و از سطوح مختلف دشواری (بر اساس سطح ${difficulty}) باشند.
      5. برای سوالات تستی، ۴ گزینه ارائه دهید که تنها یکی صحیح باشد (برای تک‌انتخابی) یا چند گزینه صحیح (برای چندانتخابی).
      6. برای سوالات صحیح/غلط، پاسخ صحیح مشخص شود (0 برای صحیح، 1 برای غلط).
      7. برای سوالات جای خالی، پاسخ‌های صحیح مشخص شوند.
      8. برای سوالات تشریحی، فقط متن سوال کافی است.
      9. برای سوالات تطبیقی، حداقل ۳ جفت ارائه دهید.
      10. برای سوالات مرتب‌سازی، حداقل ۴ آیتم ارائه دهید.
      11. سوالات باید از نظر محتوایی دقیق و بدون اشتباه باشند.
      12. نمره سوالات را 1 قرار دهید (بعداً توسط سیستم تنظیم می‌شود).

      خروجی را به صورت یک آرایه JSON با ساختار زیر برگردان:
      [
        {
          "type": "multiple" | "multi" | "truefalse" | "fill" | "essay" | "matching" | "ordering",
          "question": "متن سوال",
          "options": ["گزینه۱", "گزینه۲", "گزینه۳", "گزینه۴"], // فقط برای multiple و multi
          "correctAnswer": 0, // اندیس گزینه صحیح برای multiple، 0 یا 1 برای truefalse
          "correctAnswers": [0, 2], // اندیس گزینه‌های صحیح برای multi
          "fillAnswers": ["پاسخ۱", "پاسخ۲"], // فقط برای fill
          "matchingPairs": [{ "left": "سمت چپ", "right": "سمت راست" }, ...], // فقط برای matching
          "orderItems": ["آیتم۱", "آیتم۲", "آیتم۳", "آیتم۴"], // فقط برای ordering
          "score": 1 // عدد 1
        }
      ]

      توجه: خروجی فقط JSON باشد و هیچ توضیح اضافی نداشته باشد.
    `;

    try {
      const response = await fetch('/api/ai/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'gpt-4o-mini',
          messages: [
            { role: 'system', content: 'شما یک معلم حرفه‌ای هستید که سوالات استاندارد و دقیق بر اساس کتاب درسی ایران تولید می‌کنید.' },
            { role: 'user', content: prompt }
          ],
          temperature: 0.5,
          max_tokens: 3000,
        }),
      });

      if (!response.ok) {
        throw new Error(`خطا در ارتباط با سرور: ${response.status}`);
      }

      const data = await response.json();
      const content = data.choices[0].message.content.trim();

      let jsonString = content;
      const jsonMatch = content.match(/```(?:json)?\s*([\s\S]*?)\s*```/);
      if (jsonMatch) {
        jsonString = jsonMatch[1];
      }

      const generatedQuestions = JSON.parse(jsonString);

      if (!Array.isArray(generatedQuestions) || generatedQuestions.length === 0) {
        throw new Error('خروجی AI معتبر نیست یا هیچ سوالی تولید نشده است.');
      }

      // ===== مرحله ۱: تبدیل سوالات تولید شده به ساختار داخلی =====
      let allQuestions = generatedQuestions.map((q, index) => {
        const id = Date.now().toString(36) + Math.random().toString(36).substring(2, 9) + index;
        const base = {
          id,
          type: q.type,
          question: sanitizeHtmlGlobal(q.question),
          score: 1, // موقتاً ۱
          image: null,
          file: null,
          required: false,
          timeLimit: null,
          conditional: null,
          mathFormula: q.mathFormula || '',
          isEssay: q.type === 'essay' || q.type === 'file',
        };

        switch (q.type) {
          case 'multiple':
            return {
              ...base,
              options: q.options || ['', '', '', ''],
              correctAnswer: q.correctAnswer !== undefined ? q.correctAnswer : 0,
              correctAnswers: [],
              fillAnswers: [],
              matchingPairs: [],
              orderItems: [],
            };
          case 'multi':
            return {
              ...base,
              options: q.options || ['', '', '', ''],
              correctAnswer: 0,
              correctAnswers: q.correctAnswers || [0],
              fillAnswers: [],
              matchingPairs: [],
              orderItems: [],
            };
          case 'truefalse':
            return {
              ...base,
              options: ['صحیح', 'غلط'],
              correctAnswer: q.correctAnswer === 0 ? 0 : 1,
              correctAnswers: [],
              fillAnswers: [],
              matchingPairs: [],
              orderItems: [],
            };
          case 'fill':
            return {
              ...base,
              options: [],
              correctAnswer: 0,
              correctAnswers: [],
              fillAnswers: q.fillAnswers || [''],
              matchingPairs: [],
              orderItems: [],
            };
          case 'essay':
            return {
              ...base,
              options: [],
              correctAnswer: 0,
              correctAnswers: [],
              fillAnswers: [],
              matchingPairs: [],
              orderItems: [],
            };
          case 'matching':
            return {
              ...base,
              options: [],
              correctAnswer: 0,
              correctAnswers: [],
              fillAnswers: [],
              matchingPairs: q.matchingPairs || [{ left: '', right: '' }],
              orderItems: [],
            };
          case 'ordering':
            return {
              ...base,
              options: [],
              correctAnswer: 0,
              correctAnswers: [],
              fillAnswers: [],
              matchingPairs: [],
              orderItems: q.orderItems || ['', '', '', ''],
            };
          default:
            throw new Error(`نوع سوال نامشخص: ${q.type}`);
        }
      });

      // ===== مرحله ۲: شمارش کمبودها =====
      const requestedCounts = {
        multiple: aiConfig.numMultiple,
        multi: aiConfig.numMulti,
        truefalse: aiConfig.numTrueFalse,
        fill: aiConfig.numFill,
        essay: aiConfig.numEssay,
        matching: aiConfig.numMatching,
        ordering: aiConfig.numOrdering
      };

      // شمارش سوالات تولیدشده به تفکیک نوع
      const producedCounts = {};
      allQuestions.forEach(q => {
        const t = q.type;
        producedCounts[t] = (producedCounts[t] || 0) + 1;
      });

      // ===== مرحله ۳: تولید سوالات کمبود (مرحله اول) =====
      const missingPromises = [];
      for (const [typeKey, requested] of Object.entries(requestedCounts)) {
        if (requested === 0) continue;
        const produced = producedCounts[typeKey] || 0;
        const deficit = requested - produced;
        if (deficit > 0) {
          const promise = generateMissingQuestions(
            typeKey, deficit, grade, book, chapter, subject, aiConfig.difficulty
          ).then(missingQs => missingQs).catch(err => {
            console.error(`خطا در تولید سوالات کمبود برای نوع ${typeKey}:`, err);
            return [];
          });
          missingPromises.push(promise);
        }
      }

      if (missingPromises.length > 0) {
        setGenerationProgress(50);
        const missingResults = await Promise.all(missingPromises);
        const allMissing = missingResults.flat();
        if (allMissing.length > 0) {
          allQuestions = [...allQuestions, ...allMissing];
        }
      }

      // ===== مرحله ۴: اگر هنوز کمبود داریم، تلاش دوم (fallback) =====
      const finalCounts = {};
      allQuestions.forEach(q => {
        const t = q.type;
        finalCounts[t] = (finalCounts[t] || 0) + 1;
      });

      for (const [typeKey, requested] of Object.entries(requestedCounts)) {
        if (requested === 0) continue;
        const finalProduced = finalCounts[typeKey] || 0;
        const deficit = requested - finalProduced;
        if (deficit > 0) {
          try {
            const fallbackQs = await generateMissingQuestions(
              typeKey, deficit, grade, book, chapter, subject,
              Math.min(aiConfig.difficulty + 1, 5)
            );
            allQuestions = [...allQuestions, ...fallbackQs];
          } catch (err) {
            console.error(`تلاش دوم برای نوع ${typeKey} ناموفق:`, err);
          }
        }
      }

      // ===== مرحله ۵: مرتب‌سازی سوالات بر اساس نوع (اختیاری) =====
      const typeOrder = ['multiple', 'multi', 'truefalse', 'fill', 'essay', 'matching', 'ordering'];
      allQuestions.sort((a, b) => typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type));

      // ===== مرحله ۶: نمره‌دهی نهایی روی کل سوالات =====
      // تابع assignScores مجموع را دقیقاً ۲۰ می‌کند (حتی اگر مجبور شود از نمرات کم کند)
      allQuestions = assignScores(allQuestions);

      // ===== مرحله ۷: اضافه کردن به State =====
      setQuestions(prev => [...prev, ...allQuestions]);
      setGenerationProgress(100);

      const totalGenerated = allQuestions.length;
      const totalRequested = totalAiQuestions;
      if (totalGenerated >= totalRequested) {
        alert(`✅ ${totalGenerated} سوال با موفقیت تولید شد!`);
      } else {
        alert(`⚠️ ${totalGenerated} سوال از ${totalRequested} سوال درخواستی تولید شد.\nلطفاً سوالات کمبود را به صورت دستی اضافه کنید.`);
      }

    } catch (error) {
      // 🆕 بازگرداندن سهمیه در صورت خطا
      if (quotaConsumed) {
        try {
          await refundAIQuota(currentTeacherId);
          setAiQuota(await getAIQuota(currentTeacherId));
        } catch (e) { console.warn('refund failed', e); }
      }
      console.error('AI Generation Error:', error);
      let errorMessage = error.message || 'خطا در تولید سوالات';
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        errorMessage = 'خطا در ارتباط با سرور. لطفاً اتصال اینترنت خود را بررسی کنید.';
      } else if (!navigator.onLine) {
        errorMessage = 'اتصال اینترنت خود را بررسی کنید.';
      }
      setGenerationError(errorMessage);
      alert(`❌ ${errorMessage}`);
    } finally {
      generatingLockRef.current = false;
      setIsGenerating(false);
    }
  };

  // ===== ذخیره آزمون =====
  const handleSave = useCallback(
    async (publish = false) => {
      if (isSubmitting) return;

      if (publish && !isTotalScoreValid) {
        alert(`⚠️ برای انتشار، مجموع نمرات باید دقیقاً ۲۰ باشد.\nمجموع فعلی: ${totalScore.toFixed(2)} از ۲۰`);
        return;
      }

      // 🆕 Step Quiz Mode — شاخه‌ی مستقل با ذخیره‌سازی متفاوت
      if (isStepQuizMode && stepQuizOnSave) {
        if (!validateExam()) {
          alert('لطفاً تمام فیلدهای الزامی را تکمیل کنید.');
          return;
        }
        setIsSubmitting(true);
        setSaving(true);
        try {
          const result = await stepQuizOnSave({
            ...examInfo,
            questions: questions.map((q) => ({
              ...q,
              question: sanitizeHtmlGlobal(q.question),
              isEssay: q.type === 'essay' || q.type === 'file',
            })),
          });
          if (result?.ok) {
            if (stepQuizOnSuccess) {
              stepQuizOnSuccess();
            } else {
              stepQuizOnCancel?.();
            }
          } else {
            alert('⚠️ ذخیره‌سازی آزمون مرحله با مشکل مواجه شد. لطفاً دوباره تلاش کنید.');
          }
        } finally {
          setSaving(false);
          setIsSubmitting(false);
        }
        return;
      }

      if (!validateExam()) {
        alert('لطفاً تمام فیلدهای الزامی را تکمیل کنید.');
        return;
      }

      setIsSubmitting(true);
      setSaving(true);

      try {
        let finalTeamId = examInfo.teamId || teacherTeamId;

        if (examInfo.isGlobal) {
          finalTeamId = null;
        } else {
          if (!finalTeamId || finalTeamId === 'no-group') {
            const storedTeam = localStorage.getItem('team');
            if (storedTeam) {
              try {
                const team = JSON.parse(storedTeam);
                if (team && team.id) finalTeamId = team.id;
              } catch {
                /* ignore */
              }
            }
          }
          if (!finalTeamId || finalTeamId === 'no-group') {
            const storedMembers = localStorage.getItem('teamMembers');
            if (storedMembers) {
              try {
                const members = JSON.parse(storedMembers);
                const teacherMember = members.find(
                  (m) => m.studentId === currentTeacherId && m.status === 'active'
                );
                if (teacherMember) finalTeamId = teacherMember.teamId;
              } catch {
                /* ignore */
              }
            }
          }
          if (!finalTeamId || finalTeamId === 'no-group') finalTeamId = null;
        }

        const totalStudents = finalTeamId ? (getTeamTotalStudents(finalTeamId) || 0) : 0;

        const finalGrade = examInfo.grade === 'سایر' ? customGrade : examInfo.grade;
        const finalBook = examInfo.book === 'سایر' ? customBook : examInfo.book;
        const finalChapter = examInfo.chapter === 'سایر' ? customChapter : examInfo.chapter;
        const finalSubject = examInfo.subject === 'سایر' ? customSubject : examInfo.subject;

        const processedQuestions = questions.map((q) => ({
          ...q,
          question: sanitizeHtmlGlobal(q.question),
          isEssay: q.type === 'essay' || q.type === 'file',
          _isEssayGraded: q.type === 'essay' || q.type === 'file' ? false : true,
        }));

        let dateToSave = examInfo._gregorianDate;
        if (!dateToSave && examInfo.date) {
          try {
            dateToSave = moment(examInfo.date, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
          } catch (e) {
            dateToSave = '';
          }
        }

        let startTimeToSave = '';
        let endTimeToSave = '';
        if (dateToSave && examInfo.startTime) {
          startTimeToSave = `${dateToSave}T${examInfo.startTime}`;
        }
        if (dateToSave && examInfo.endTime) {
          endTimeToSave = `${dateToSave}T${examInfo.endTime}`;
        }

        const examData = {
          ...examInfo,
          date: dateToSave,
          startTime: startTimeToSave,
          endTime: endTimeToSave,
          questions: processedQuestions,
          published: publish,
          totalStudents: examInfo.isGlobal ? 0 : totalStudents,
          status: publish ? 'فعال' : 'در انتظار',
          statusType: publish ? 'active' : 'pending',
          teamId: examInfo.isGlobal ? null : finalTeamId,
          teacherId: examInfo.teacherId || currentTeacherId,
          needsCorrection: processedQuestions.some((q) => q.isEssay),
          createdAt: isEditing ? existingExam?.createdAt : new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          isGlobal: examInfo.isGlobal,
          grade: finalGrade,
          field: examInfo.field || null,          // 🔽 CHANGED
          fieldTitle: examInfo.fieldTitle || '',  // 🔽 CHANGED
          subject: finalSubject,
          book: finalBook,
          chapter: finalChapter,
        };

        let savedExam;
        if (isEditing && examId) {
          updateExam(examId, examData);
          savedExam = getExam(examId);
        } else {
          const newExam = addExam(examData);
          savedExam = newExam;
        }

        if (!savedExam) {
          throw new Error('ذخیره‌سازی آزمون با شکست مواجه شد.');
        }

        // انتقال تصاویر
        let needsImageUpdate = false;
        let tempId = null;
        for (const q of processedQuestions) {
          if (q.image && q.image.includes('temp_')) {
            needsImageUpdate = true;
            const match = q.image.match(/temp_[^/]+/);
            if (match) {
              tempId = match[0];
              break;
            }
          }
        }

        if (needsImageUpdate && tempId && savedExam.id) {
          try {
            await moveExamImages(currentTeacherId, savedExam.id, tempId);

            // 🆕 آپدیت مسیر تصویر اصلی آزمون (cover) — چون کل پوشه‌ی temp
            //    به examId منتقل می‌شود، مسیر دیتابیس هم باید عوض شود.
            let updatedExamImage = savedExam.image;
            if (updatedExamImage && updatedExamImage.includes(`/exams/${currentTeacherId}/temp/`)) {
              updatedExamImage = updatedExamImage.replace(
                `/exams/${currentTeacherId}/temp/`,
                `/exams/${currentTeacherId}/${savedExam.id}/`
              );
            }

            const updatedQuestions = processedQuestions.map((q) => {
              if (q.image && q.image.includes('temp_')) {
                const newPath = q.image.replace(
                  `/exams/${currentTeacherId}/temp/`,
                  `/exams/${currentTeacherId}/${savedExam.id}/`
                );
                return { ...q, image: newPath };
              }
              return q;
            });
            updateExam(savedExam.id, {
              ...savedExam,
              image: updatedExamImage,          // 🆕
              questions: updatedQuestions,
            });
            console.log('✅ تصاویر با موفقیت به پوشه نهایی منتقل شدند.');
          } catch (moveError) {
            console.error('❌ خطا در انتقال تصاویر:', moveError);
            alert('⚠️ تصاویر با موفقیت آپلود شدند اما انتقال به پوشه نهایی با مشکل مواجه شد. لطفاً با پشتیبانی تماس بگیرید.');
          }
        }


                // 🆕 پاک‌سازی draft
        if (DRAFT_KEY) {
          try { localStorage.removeItem(DRAFT_KEY); } catch {}
        }


        navigate('/exams/teacher');
      } catch (error) {
        console.error('Error saving exam:', error);
        alert(error.message || 'خطا در ذخیره آزمون. لطفاً دوباره تلاش کنید.');
      } finally {
        setSaving(false);
        setIsSubmitting(false);
      }
    },
    [
      examInfo,
      questions,
      teacherTeamId,
      currentTeacherId,
      isEditing,
      examId,
      addExam,
      updateExam,
      navigate,
      getTeamTotalStudents,
      getExam,
      isSubmitting,
      totalScore,
      isTotalScoreValid,
      existingExam,
      customGrade,
      customBook,
      customChapter,
      customSubject,
      moveExamImages,
      // 🆕 Step Quiz deps
      isStepQuizMode,
      stepQuizOnSave,
      stepQuizOnCancel,
      stepQuizOnSuccess,
    ]
  );

  const handlePublish = () => handleSave(true);





  // 🆕 خرید اشتراک AI
  const handleBuySubscription = async (planId) => {
    if (!currentTeacherId) {
      alert('لطفاً ابتدا وارد شوید');
      return;
    }
    const plan = AI_PLANS[planId];
    if (!plan) return;

    // ⚠️ مهم: plan.id باید دقیقاً یکی از مقادیر کلید PRICES.ai_subscription روی سرور باشه
    // سرور فقط 'monthly' یا 'yearly' رو می‌شناسه.
    const serverPlanId =
      plan.id === 'monthly' || plan.id === 'yearly'
        ? plan.id
        : (plan.months === 12 ? 'yearly' : 'monthly');

    setSubLoading(planId);
    try {
      await startPayment({
        userId: currentTeacherId,
        purpose: PAYMENT_PURPOSE.AI_SUBSCRIPTION,   // ← کانالیکال، نه alias
        metadata: {
          plan: serverPlanId,   // ← فقط چیزهایی که سرور می‌فهمه
          months: plan.months,
        },
        description: `خرید ${plan.title} - ساخت نامحدود آزمون با AI`,
      });
    } catch (err) {
      console.error('Payment error:', err);
      alert('❌ خطا در شروع پرداخت: ' + (err.message || 'مشکل نامشخص'));
      setSubLoading(null);
    }
  };

  // ===== تولید PDF =====
  const goToPdfEditor = () => {
    // 🆕 قبل از رفتن به PDF، state رو ذخیره کن (شامل aiConfig)
    try {
      localStorage.setItem('exam-pdf-backup', JSON.stringify({
        examInfo, questions, aiConfig,
        customGrade, customBook, customChapter, customSubject,
        customGradeConfirmed, customBookConfirmed,
        customChapterConfirmed, customSubjectConfirmed,
      }));
    } catch {}
    navigate('/exams/exampdf', { state: { examData: { ...examInfo, questions } } });
  };

  // ===== رندر لیست سوالات =====
  const renderQuestionsList = () => {
    if (questions.length === 0) {
      return (
        <div className="emptyQuestions">
          <span>📝</span>
          <p>هنوز سوالی اضافه نشده است.</p>
          <p className="emptyHint">با دکمه "تولید سوالات با هوش مصنوعی" سوالات را به‌صورت خودکار بسازید یا به صفحه ساخت دستی مراجعه کنید.</p>
        </div>
      );
    }
    return (
      <div className="questionsList">
        {questions.map((q, idx) => (
          <div key={q.id} className="questionItem">
            <div className="questionHeader">
              <span className="questionNumber">سوال {idx + 1}</span>
              <span className={classNames('questionType', q.type)}>
                {q.type === 'multiple' && '✅ تک‌انتخابی'}
                {q.type === 'multi' && '☑️ چندانتخابی'}
                {q.type === 'truefalse' && '⚖️ صحیح/غلط'}
                {q.type === 'fill' && '📝 جای خالی'}
                {q.type === 'essay' && '📄 تشریحی'}
                {q.type === 'file' && '📎 فایل'}
                {q.type === 'matching' && '🔗 تطبیقی'}
                {q.type === 'ordering' && '📊 مرتب‌سازی'}
              </span>
              <span className="questionScore">نمره: {toNumber(q.score, 1)}</span>
              {q.required && <span className="requiredBadge">الزامی</span>}
              {q.isEssay && <span className="essayBadge">📝 تشریحی</span>}
              <div className="questionActions">
                <button className="editBtn" onClick={() => editQuestion(q.id)} title="ویرایش">✏️</button>
                <button className="duplicateBtn" onClick={() => duplicateQuestion(q.id)} title="کپی">📋</button>
                <button className="removeBtn" onClick={() => removeQuestion(q.id)} title="حذف">🗑️</button>
                <button className="moveUpBtn" onClick={() => moveQuestion(idx, 'up')} disabled={idx === 0}>↑</button>
                <button className="moveDownBtn" onClick={() => moveQuestion(idx, 'down')} disabled={idx === questions.length - 1}>↓</button>
              </div>
            </div>
            <div className="questionText" dangerouslySetInnerHTML={{ __html: sanitizeHtmlGlobal(q.question) }} />
            {q.mathFormula && <div className="mathDisplay"><span className="mathLabel">📐 فرمول: </span><span className="mathFormulaDisplay">{q.mathFormula}</span></div>}
            {q.image && <div className="questionImage"><img src={getImageUrl(q.image)} alt="تصویر سوال" /></div>}
            {q.file && <div className="questionFile"><span>📎 فایل ضمیمه</span></div>}
            {q.type === 'multiple' && (
              <div className="questionOptions">{q.options.map((opt, oi) => <div key={oi} className="questionOption"><span className="optionLetter">{String.fromCharCode(65 + oi)}.</span><span className={q.correctAnswer === oi ? 'correctOption' : ''}>{opt}</span>{q.correctAnswer === oi && <span className="correctBadge">✓</span>}</div>)}</div>
            )}
            {q.type === 'multi' && (
              <div className="questionOptions">{q.options.map((opt, oi) => <div key={oi} className="questionOption"><span className="optionLetter">{String.fromCharCode(65 + oi)}.</span><span className={q.correctAnswers.includes(oi) ? 'correctOption' : ''}>{opt}</span>{q.correctAnswers.includes(oi) && <span className="correctBadge">✓</span>}</div>)}</div>
            )}
            {q.type === 'fill' && <div className="questionFillAnswers"><span className="answerLabel">پاسخ‌ها: </span>{q.fillAnswers.map((ans, fi) => <span key={fi} className="fillAnswerTag">{ans}</span>)}</div>}
            {q.type === 'matching' && <div className="questionMatching">{q.matchingPairs.map((pair, mi) => <div key={mi} className="matchingPairDisplay"><span>{pair.left}</span><span className="matchingArrowDisplay">⟷</span><span>{pair.right}</span></div>)}</div>}
            {q.type === 'ordering' && <div className="questionOrdering">{q.orderItems.map((item, oi) => <span key={oi} className="orderItemDisplay">{oi + 1}. {item}</span>)}</div>}
          </div>
        ))}
      </div>
    );
  };

  // ===== رندر مجموع نمرات =====
  const renderTotalScoreInfo = () => {
    const isComplete = Math.abs(totalScore - 20) < 0.01;
    const isOver = totalScore > 20 + 0.01;
    const remaining = 20 - totalScore;

    return (
      <div className={`totalScoreInfo ${isComplete ? 'complete' : isOver ? 'over' : ''}`}>
        <div className="totalScoreHeader">
          <span className="totalScoreIcon">📊</span>
          <span className="totalScoreLabel">مجموع نمرات تا الان:</span>
          <span className="totalScoreValue">
            {toPersianDigits(totalScore.toFixed(2))} از {toPersianDigits(20)}
          </span>
          {isComplete && <span className="totalScoreCompleteBadge">✅ کامل</span>}
          {isOver && <span className="totalScoreOverBadge">⚠️ بیش از حد</span>}
          {!isComplete && !isOver && (
            <span className="totalScoreRemaining">
              ({toPersianDigits(remaining.toFixed(2))} نمره باقی‌مانده)
            </span>
          )}
        </div>
        {isComplete && (
          <div className="totalScoreMessage success">
            ✅ شما به حداکثر مجموع نمره (۲۰) رسیدید.
          </div>
        )}
        {isOver && (
          <div className="totalScoreMessage error">
            ⚠️ مجموع نمرات از ۲۰ بیشتر شده است. لطفاً نمرات سوالات را کاهش دهید.
          </div>
        )}
        {!isComplete && !isOver && questions.length > 0 && (
          <div className="totalScoreMessage info">
            💡 برای انتشار آزمون، مجموع نمرات باید دقیقاً ۲۰ شود.
          </div>
        )}
        {questions.length === 0 && (
          <div className="totalScoreMessage info">
            📝 حداقل یک سوال اضافه کنید. مجموع نمرات باید ۲۰ شود.
          </div>
        )}
      </div>
    );
  };

  // ===== اگر معلم گروه ندارد =====
  if (!isStepQuizMode && !teacherTeamId && !isEditing && !examInfo.isGlobal) {
    return (
      <div className={`create-exam-ai-container ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className="card" style={{ textAlign: 'center', padding: '60px 20px' }}>
          <span style={{ fontSize: '64px' }}>🏫</span>
          <h2 style={{ marginTop: '16px', color: '#1e293b' }}>⚠️ شما به هیچ گروهی متصل نیستید!</h2>
          <p style={{ color: '#64748b', marginTop: '8px' }}>
            برای ساخت آزمون گروهی، بهتر است ابتدا یک گروه ایجاد کنید یا به یک گروه متصل شوید.
            <br />
            <span style={{ fontSize: '14px', color: '#f59e0b' }}>⚠️ در غیر این صورت آزمون بدون گروه ذخیره می‌شود.</span>
            {isAdmin && <br />}
            {isAdmin && <span style={{ fontSize: '14px', color: '#a78bfa' }}>🌟 شما ادمین ویژه هستید و می‌توانید آزمون عمومی بسازید.</span>}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '20px' }}>
            <button className="btn btnPrimary" onClick={() => navigate('/team-dashboard')}>🚀 رفتن به داشبورد گروه</button>
            <button className="btn btnOutline" onClick={() => setTeacherTeamId('no-group')}>⏩ ادامه بدون گروه</button>
            {isAdmin && (
              <button className="btn btnSecondary" onClick={() => setExamInfo(prev => ({ ...prev, isGlobal: true }))}>
                🌍 ساخت آزمون عمومی
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ============================================================
  // ===== رندر اصلی =====
  // ============================================================
  return (
    <div className={`create-exam-ai-container ${isDarkMode ? 'dark-mode' : ''}`}>
      <header className="header">
        <div className="headerLeft">
          <button
            className="backBtn"
            onClick={isStepQuizMode ? stepQuizOnCancel : () => navigate('/exams/teacher')}
          >
            ← بازگشت
          </button>
          <h1 className="headerTitle">
            {isStepQuizMode
              ? '🧠 ساخت آزمون مرحله (AI)'
              : (isEditing ? '✏️ ویرایش آزمون' : '🧠 ساخت آزمون با هوش مصنوعی')}
            {examInfo.isGlobal && !examInfo.isChallenge && <span className="globalBadge">🌍 عمومی</span>}
            {examInfo.isChallenge && <span className="challengeBadge">🏆 چالش</span>}
          </h1>
          {isEditing && <span className="editBadge">ویرایش</span>}
        </div>
        <div className="headerActions">

                  {/*<button
            className="themeToggleBtn"
            onClick={toggleTheme}
            title={isDarkMode ? 'حالت روشن' : 'حالت تیره'}
          >
            {isDarkMode ? '☀️' : '🌙'}
          </button>*/}

          <button
            className="btn btnOutline"
            onClick={isStepQuizMode ? stepQuizOnCancel : () => navigate('/exams/teacher')}
          >
            انصراف
          </button>
          <button className="btn btnSecondary" onClick={() => handleSave(false)} disabled={saving}>{saving ? '⏳ در حال ذخیره...' : '💾 ذخیره موقت'}</button>
          <button
            className={`btn btnPrimary ${!isTotalScoreValid ? 'btnDisabled' : ''}`}
            onClick={handlePublish}
            disabled={saving || !isTotalScoreValid}
            title={!isTotalScoreValid ? 'مجموع نمرات باید ۲۰ باشد' : ''}
          >
            {saving ? '⏳ در حال انتشار...' : isEditing ? '📤 به‌روزرسانی' : '🚀 انتشار'}
          </button>
        </div>
      </header>

      {/* ===== بخش اطلاعات پایه ===== */}
      <section className="card">
        <h3 className="cardTitle">📋 اطلاعات پایه</h3>
        <div className="formGrid">
          <div className="formGroup">
            <label className="fieldLabel">عنوان آزمون <span className="required">*</span></label>
            <input type="text" name="title" className={classNames('textInput', errors.title && 'error')} value={examInfo.title} onChange={handleExamInfoChange} placeholder="مثال: آزمون نهایی فصل ۳ ریاضی" />
            {errors.title && <span className="errorMsg">{errors.title}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">پایه تحصیلی <span className="required">*</span></label>
            <select
              className={classNames('selectInput', errors.grade && 'error')}
              value={examInfo.grade}
              onChange={(e) => handleGradeChange(e.target.value)}
            >
              <option value="">-- انتخاب پایه --</option>
              {gradeOptions.map(grade => (
                <option key={grade} value={grade}>{grade}</option>
              ))}
              {/*<option value="سایر">سایر (دستی)</option>*/}
            </select>
            {examInfo.grade === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="پایه را وارد کنید..."
                  value={customGrade}
                  onChange={(e) => {
                    setCustomGrade(e.target.value);
                    setCustomGradeConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customGrade.trim()) {
                      setCustomGradeConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.grade && <span className="errorMsg">{errors.grade}</span>}
          </div>

          {/* 🔽 CHANGED: انتخاب رشته — فقط برای پایه‌های ۱۰-۱۲ */}
          {examInfo.grade && curriculumNeedsField(examInfo.grade) && (
            <div className="formGroup">
              <label className="fieldLabel">
                رشته تحصیلی <span className="required">*</span>
              </label>
              <select
                className={classNames('selectInput', errors.field && 'error')}
                value={examInfo.field || ''}
                onChange={(e) => handleFieldChange(e.target.value)}
              >
                <option value="">-- انتخاب رشته --</option>
                {FIELD_LIST.map((f) => (
                  <option key={f.id} value={f.id}>{f.title}</option>
                ))}
              </select>
              {errors.field && <span className="errorMsg">{errors.field}</span>}
            </div>
          )}

          <div className="formGroup">
            <label className="fieldLabel">کتاب <span className="required">*</span></label>
            <select
              className={classNames('selectInput', errors.book && 'error')}
              value={examInfo.book}
              onChange={(e) => handleBookChange(e.target.value)}
              disabled={!examInfo.grade || (examInfo.grade === 'سایر' && !customGradeConfirmed)}
            >
              <option value="">-- انتخاب کتاب --</option>
              {availableBooks.map(book => (
                <option key={book} value={book}>{book}</option>
              ))}
              {/*<option value="سایر">سایر (دستی)</option>*/}
            </select>
            {examInfo.book === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="کتاب را وارد کنید..."
                  value={customBook}
                  onChange={(e) => {
                    setCustomBook(e.target.value);
                    setCustomBookConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customBook.trim()) {
                      setCustomBookConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.book && <span className="errorMsg">{errors.book}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">فصل {examInfo.isGlobal && <span className="required">*</span>}</label>
            <select
              className={classNames('selectInput', errors.chapter && 'error')}
              value={examInfo.chapter}
              onChange={(e) => handleChapterChange(e.target.value)}
              disabled={!examInfo.book || (examInfo.book === 'سایر' && !customBookConfirmed)}
            >
              <option value="">-- انتخاب فصل --</option>
              {availableChapters.map(chapter => (
                <option key={chapter} value={chapter}>{chapter}</option>
              ))}
              <option value="سایر">سایر (کل کتاب , فصل ... تا ...)</option>
            </select>
            {examInfo.chapter === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="فصل را وارد کنید..."
                  value={customChapter}
                  onChange={(e) => {
                    setCustomChapter(e.target.value);
                    setCustomChapterConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customChapter.trim()) {
                      setCustomChapterConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.chapter && <span className="errorMsg">{errors.chapter}</span>}
          </div>

          {/*<div className="formGroup">
            <label className="fieldLabel">درس {examInfo.isGlobal && <span className="required">*</span>}</label>
            <select
              className={classNames('selectInput', errors.subject && 'error')}
              value={examInfo.subject}
              onChange={(e) => handleSubjectChange(e.target.value)}
              disabled={!examInfo.chapter || (examInfo.chapter === 'سایر' && !customChapterConfirmed)}
            >
              <option value="">-- انتخاب درس --</option>
              {availableLessons.map(lesson => (
                <option key={lesson} value={lesson}>{lesson}</option>
              ))}
              <option value="سایر">سایر (دستی)</option>
            </select>
            {examInfo.subject === 'سایر' && (
              <div style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="textInput"
                  placeholder="درس را وارد کنید..."
                  value={customSubject}
                  onChange={(e) => {
                    setCustomSubject(e.target.value);
                    setCustomSubjectConfirmed(false);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="btn btnPrimary"
                  style={{ padding: '6px 12px', fontSize: '13px', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    if (customSubject.trim()) {
                      setCustomSubjectConfirmed(true);
                    } else {
                      alert('لطفاً مقدار را وارد کنید');
                    }
                  }}
                >
                  ✔ ثبت
                </button>
              </div>
            )}
            {errors.subject && <span className="errorMsg">{errors.subject}</span>}
          </div>*/}

          <div className="formGroup">
            <label className="fieldLabel">تاریخ برگزاری {!examInfo.isGlobal && <span className="required">*</span>}</label>
            <PersianDatePicker
              value={examInfo.date}
              onChange={handleDateChange}
              placeholder="انتخاب تاریخ برگزاری..."
              className={classNames('textInput', errors.date && 'error')}
            />
            {errors.date && <span className="errorMsg">{errors.date}</span>}
          </div>

          <div className="formGroup">
            <label className="fieldLabel">مدت زمان (دقیقه) <span className="required">*</span></label>
            <input type="number" name="duration" className={classNames('textInput', errors.duration && 'error')} value={examInfo.duration} onChange={handleExamInfoChange} placeholder="مثال: ۹۰" min="1" required />
            {errors.duration && <span className="errorMsg">{errors.duration}</span>}
          </div>

          {/*{!examInfo.isGlobal && (
            <div className="formGroup">
              <label className="fieldLabel">تعداد دانش‌آموزان گروه</label>
              <input type="text" className="textInput" value={`${teamTotalStudents} نفر`} disabled style={{ background: '#f1f5f9', cursor: 'not-allowed' }} />
            </div>
          )}*/}

          {examInfo.isGlobal && (
            <div className="formGroup">
              <label className="fieldLabel">نوع آزمون</label>
              <input type="text" className="textInput" value={examInfo.isChallenge ? '🏆 چالش ویژه' : '🌍 عمومی - برای همه دانش‌آموزان'} disabled style={{ background: '#f1f5f9', cursor: 'not-allowed', color: examInfo.isChallenge ? '#f59e0b' : '#7c3aed' }} />
            </div>
          )}

          <div className="formGroup">
            <label className="fieldLabel">توضیحات صفحه شروع</label>
            <textarea name="description" className="textArea" value={examInfo.description} onChange={handleExamInfoChange} placeholder="دستورالعمل یا توضیحات تکمیلی..." rows="2" />
          </div>

<div className="formGroup">
  <label className="fieldLabel">تصویر صفحه توضیحات</label>
  <div className="imageUploadBox">
    {isUploadingExamImage ? (
      <div className="imageUploadSpinner">
        <div className="uploadSpinner" />
        <span>در حال آپلود...</span>
      </div>
    ) : examInfo.image ? (
      <div className="examImagePreview">
        <img src={getImageUrl(examInfo.image)} alt="تصویر شاخص" />
        <button
          type="button"
          className="removeImageBtn"
          onClick={async () => {
            const old = examInfo.image;
            setExamInfo(prev => ({ ...prev, image: null }));
            if (old) {
              try {
                await deleteImage(old);
              } catch (err) {
                console.warn('حذف تصویر ناموفق بود:', err);
              }
            }
          }}
        >
          ✕
        </button>
      </div>
    ) : (
      <label className="imageUploadLabel">
        <input
          type="file"
          accept="image/*"
          onChange={handleExamImageUpload}
          style={{ display: 'none' }}
        />
        <div className="imageUploadIcon">📷</div>
        <div className="imageUploadText">برای انتخاب تصویر کلیک کنید</div>
        <div className="imageUploadHint">PNG، JPG — حداکثر ۲ مگابایت</div>
      </label>
    )}
  </div>
</div>
        </div>
      </section>

      {/* ===== تنظیمات پیشرفته ===== */}
      <section className="card">
        <h3
          className="cardTitle"
          style={{
            cursor: 'pointer',
            userSelect: 'none',
            justifyContent: 'space-between',
            marginBottom: showAdvancedSettings ? '18px' : '0',
          }}
          onClick={() => setShowAdvancedSettings((v) => !v)}
          title={showAdvancedSettings ? 'بستن تنظیمات' : 'باز کردن تنظیمات'}
        >
          <span>⚙️ تنظیمات پیشرفته</span>
          <span
            style={{
              display: 'inline-block',
              transition: 'transform 0.25s ease',
              transform: showAdvancedSettings ? 'rotate(180deg)' : 'rotate(0deg)',
              fontSize: '14px',
              color: 'var(--text-secondary)',
              opacity: 0.75,
            }}
          >
            ▼
          </span>
        </h3>
        {showAdvancedSettings && (
          <div className="settingsGrid">
            <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="shuffleQuestions" checked={examInfo.shuffleQuestions} onChange={handleExamInfoChange} /> نمایش تصادفی سوالات</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="shuffleOptions" checked={examInfo.shuffleOptions} onChange={handleExamInfoChange} /> نمایش تصادفی گزینه‌ها</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="showResult" checked={examInfo.showResult} onChange={handleExamInfoChange} /> نمایش نتیجه به کاربر</label></div>
          <div className="settingItem"><label className="checkboxLabel"><input type="checkbox" name="showCorrectAnswers" checked={examInfo.showCorrectAnswers} onChange={handleExamInfoChange} /> نمایش پاسخ‌های صحیح</label></div>

          {isAdmin && (
            <section className="card" style={{ gridColumn: '1 / -1', marginTop: '12px' }}>
              <h3 className="cardTitle">🏆 تنظیمات چالش ویژه</h3>
              <div className="settingsGrid">
                <div className="settingItem">
                  <label className="checkboxLabel">
                    <input
                      type="checkbox"
                      name="isChallenge"
                      checked={examInfo.isChallenge}
                      onChange={handleExamInfoChange}
                    />
                    این آزمون به عنوان چالش ویژه نمایش داده شود
                  </label>
                  <span style={{ fontSize: '12px', color: '#6b7280', marginRight: '8px', display: 'block' }}>
                    (چالش‌ها در بخش مجزای "چالش‌ها" نمایش داده می‌شوند)
                  </span>
                </div>

                {examInfo.isChallenge && (
                  <>
                    <div className="settingItem">
                      <label className="checkboxLabel">
                        <input
                          type="checkbox"
                          name="isDailyChallenge"
                          checked={examInfo.isDailyChallenge}
                          onChange={handleExamInfoChange}
                        />
                        📅 این چالش به عنوان چالش روزانه نمایش داده شود
                      </label>
                      <span style={{ fontSize: '12px', color: '#6b7280', display: 'block' }}>
                        (چالش روزانه فقط در روز برگزاری و تا زمانی که کاربر آن را انجام ندهد، نمایش داده می‌شود)
                      </span>
                    </div>

                    <div className="settingItem">
                      <label>🌟 عالی (نمره = ۲۰)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsExcellent" className="textInput" value={examInfo.coinsExcellent} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpExcellent" className="textInput" value={examInfo.xpExcellent} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>🎉 خیلی خوب (نمره ۱۶ تا ۱۹)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsVeryGood" className="textInput" value={examInfo.coinsVeryGood} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpVeryGood" className="textInput" value={examInfo.xpVeryGood} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>👍 خوب (نمره ۱۲ تا ۱۵)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsGood" className="textInput" value={examInfo.coinsGood} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpGood" className="textInput" value={examInfo.xpGood} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>💪 نیاز به تلاش (نمره ۸ تا ۱۱)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsNeedsWork" className="textInput" value={examInfo.coinsNeedsWork} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpNeedsWork" className="textInput" value={examInfo.xpNeedsWork} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>📖 غیر قابل قبول (نمره ۴ تا ۷)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsUnacceptable" className="textInput" value={examInfo.coinsUnacceptable} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpUnacceptable" className="textInput" value={examInfo.xpUnacceptable} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <div className="settingItem">
                      <label>🔄 مردود (نمره ۰ تا ۳)</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <input type="number" name="coinsFailed" className="textInput" value={examInfo.coinsFailed} onChange={handleExamInfoChange} placeholder="سکه" min="0" style={{ flex: 1 }} />
                        <input type="number" name="xpFailed" className="textInput" value={examInfo.xpFailed} onChange={handleExamInfoChange} placeholder="XP" min="0" style={{ flex: 1 }} />
                      </div>
                    </div>
                    <p style={{ fontSize: '13px', color: '#64748b', gridColumn: '1 / -1' }}>
                      ⚠️ این جوایز پس از اتمام چالش به کاربر تعلق می‌گیرد.
                    </p>
                  </>
                )}
              </div>
          </section>
        )}

        {/* 🆕 تنظیمات Badge آزمون — فقط ادمین ویژه */}
        {isAdmin && (
          <section className="card" style={{ gridColumn: '1 / -1', marginTop: '12px' }}>
            <h3 className="cardTitle">🏷️ تنظیمات نمایش آزمون (Badgeها)</h3>
            <div className="settingsGrid">

              <div className="settingItem">
                <label className="fieldLabel">💰 هزینه ورود (سکه)</label>
                <input
                  type="number"
                  name="requiredCoins"
                  className="textInput"
                  value={examInfo.requiredCoins || 0}
                  onChange={handleExamInfoChange}
                  min="0"
                  placeholder="۰ = رایگان"
                />
                <span style={{ fontSize: 12, color: '#6b7280' }}>
                  {examInfo.requiredCoins > 0
                    ? `🥇 آزمون طلایی (${examInfo.requiredCoins} سکه)`
                    : '🆓 آزمون رایگان'}
                </span>
              </div>

              <div className="settingItem">
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="forceNew"
                    checked={examInfo.forceNew || false}
                    onChange={handleExamInfoChange}
                  />
                  ✨ نمایش به‌عنوان «جدید» (دستی)
                </label>
              </div>

              {examInfo.forceNew && (
                <div className="settingItem">
                  <label className="fieldLabel">مدت نمایش «جدید» (ساعت)</label>
                  <input
                    type="number"
                    name="newBadgeDuration"
                    className="textInput"
                    value={examInfo.newBadgeDuration || 168}
                    onChange={handleExamInfoChange}
                    min="0"
                    step="24"
                    placeholder="۲۴ = روز، ۱۶۸ = هفته"
                  />
                </div>
              )}

              <div className="settingItem">
                <label className="checkboxLabel">
                  <input
                    type="checkbox"
                    name="forceHot"
                    checked={examInfo.forceHot || false}
                    onChange={handleExamInfoChange}
                  />
                  🔥 نمایش به‌عنوان «داغ» (دستی)
                </label>
              </div>

              <div className="settingItem">
                <label className="fieldLabel">آستانه خودکار «داغ» (شرکت‌کننده)</label>
                <input
                  type="number"
                  name="hotThresholdParticipants"
                  className="textInput"
                  value={examInfo.hotThresholdParticipants ?? 1000}
                  onChange={handleExamInfoChange}
                  min="0"
                  placeholder="۱۰۰۰"
                />
              </div>

              <p style={{ fontSize: 13, color: '#64748b', gridColumn: '1 / -1' }}>
                ⚠️ این تنظیمات فقط برای آزمون‌های عمومی و چالش‌ها کاربرد دارد.
              </p>
            </div>
          </section>
        )}

          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>نحوه نمایش سوالات</label>
            <select name="displayMode" className="selectInput" value={examInfo.displayMode} onChange={handleExamInfoChange}>
              <option value="step">هر مرحله یک سوال</option>
              <option value="all">همه سوالات در یک صفحه</option>
            </select>
          </div>

          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>زمان شروع (ورود)</label>
            <TimePicker
              value={examInfo.startTime}
              onChange={handleStartTimeChange}
              placeholder="ساعت شروع"
              label="زمان شروع"
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>⏰ از این زمان به بعد دانش‌آموزان می‌توانند وارد آزمون شوند</span>
          </div>
          <div className="settingItem">
            <label className="fieldLabel" style={{ fontSize: '14px' }}>زمان پایان (ورود)</label>
            <TimePicker
              value={examInfo.endTime}
              onChange={(value) => {
                if (!examInfo.startTime && value) {
                  alert('⚠️ ابتدا زمان شروع را انتخاب کنید');
                  return;
                }
                handleEndTimeChange(value);
              }}
              placeholder="ساعت پایان"
              label="زمان پایان"
              minTime={examInfo.startTime}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>⏰ بعد از این زمان دانش‌آموزان نمی‌توانند وارد آزمون شوند</span>
          </div>
          {errors.timeRange && <div className="errorMsg" style={{ color: '#dc2626', marginTop: '8px', gridColumn: '1 / -1' }}>⚠️ {errors.timeRange}</div>}
          </div>
        )}
      </section>

      {/* ===== بخش تولید با هوش مصنوعی ===== */}
      <section className="card ai-card">
        <h3 className="cardTitle">🧠 تولید سوالات با هوش مصنوعی</h3>

        {/* 🆕 نوار نمایش سهمیه */}
        {currentTeacherId && !aiQuotaLoading && (
          <div className="ai-quota-bar">
            {aiSubscription ? (
              <div className="ai-quota-subscribed">
                <span className="ai-quota-badge">⭐ اشتراک فعال</span>
                <span className="ai-quota-text">
                  {AI_PLANS[aiSubscription.plan]?.title || 'اشتراک ویژه'} — اعتبار تا {formatAIExpiry(aiSubscription.expiresAt)}
                </span>
              </div>
            ) : (() => {
              const used = aiQuota?.used || 0;
              const limit = aiQuota?.limit || FREE_DAILY_LIMIT;
              const remaining = Math.max(0, limit - used);
              const isExhausted = remaining === 0;
              return (
                <div className={classNames('ai-quota-free', isExhausted && 'exhausted')}>
                  <span className="ai-quota-badge">
                    {isExhausted ? '🚫 سهمیه امروز تمام شد' : `🎯 ${toPersianDigits(remaining)} آزمون رایگان باقی مانده`}
                  </span>
                  <span className="ai-quota-text">
                    امروز {toPersianDigits(used)} از {toPersianDigits(limit)} استفاده شده
                  </span>
                  {isExhausted && (
                    <button
                      type="button"
                      className="btn btnUpgrade"
                      onClick={() => setShowSubModal(true)}
                    >
                      ⭐ ارتقاء به اشتراک
                    </button>
                  )}
                </div>
              );
            })()}
          </div>
        )}

        <div className="ai-config-grid">
          <div className="ai-config-item">
            <label className="fieldLabel">سطح دشواری</label>
            <div className="difficulty-slider">
              <input
                type="range"
                min="1"
                max="5"
                step="1"
                value={aiConfig.difficulty}
                onChange={(e) => setAiConfig(prev => ({ ...prev, difficulty: parseInt(e.target.value) }))}
                className="difficulty-range"
              />
              <div className="difficulty-labels">
                <span>خیلی آسان</span>
                <span>آسان</span>
                <span>متوسط</span>
                <span>سخت</span>
                <span>خیلی سخت</span>
              </div>
              <div className="difficulty-current" style={{ background: ['#34d399', '#60a5fa', '#fbbf24', '#f59e0b', '#ef4444'][aiConfig.difficulty - 1] }}>
                سطح {aiConfig.difficulty}
              </div>
            </div>
          </div>

          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات تستی (تک‌انتخابی)</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numMultiple} onChange={(e) => setAiConfig(prev => ({ ...prev, numMultiple: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
          {/*<div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات چندانتخابی</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numMulti} onChange={(e) => setAiConfig(prev => ({ ...prev, numMulti: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>*/}
          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات صحیح/غلط</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numTrueFalse} onChange={(e) => setAiConfig(prev => ({ ...prev, numTrueFalse: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات جای خالی</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numFill} onChange={(e) => setAiConfig(prev => ({ ...prev, numFill: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات تشریحی</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numEssay} onChange={(e) => setAiConfig(prev => ({ ...prev, numEssay: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات تطبیقی</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numMatching} onChange={(e) => setAiConfig(prev => ({ ...prev, numMatching: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
          <div className="ai-config-item">
            <label className="fieldLabel">تعداد سوالات مرتب‌سازی</label>
            <input type="number" min="0" max="20" className="textInput" value={aiConfig.numOrdering} onChange={(e) => setAiConfig(prev => ({ ...prev, numOrdering: Math.max(0, parseInt(e.target.value) || 0) }))} />
          </div>
        </div>
        <div className="ai-actions">
          <button
            className="btn btnAi"
            onClick={generateQuestionsWithAI}
            disabled={
              isGenerating ||
              aiQuotaLoading ||
              (!aiSubscription && aiQuota && aiQuota.used >= (aiQuota.limit ?? FREE_DAILY_LIMIT))
            }
          >
            {isGenerating ? (
              <>
                <span className="spinner">⏳</span> در حال تولید... {generationProgress}%
              </>
            ) : (
              <>
                <FiCpu /> تولید سوالات با هوش مصنوعی
              </>
            )}
          </button>
          {generationError && (
            <div className="generation-error">
              ❌ {generationError}
            </div>
          )}
          {isGenerating && (
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${generationProgress}%` }} />
            </div>
          )}
        </div>
        <p className="ai-note">
          ⚡ هوش مصنوعی سوالات را بر اساس کتاب درسی، فصل و سطح دشواری تولید می‌کند. در صورت کمبود، به‌طور خودکار سوالات تکمیلی تولید می‌شود. نمرات نیز به‌صورت هوشمند توزیع می‌شوند.
        </p>
      </section>

      {/* ===== مدیریت سوالات ===== */}
      <section className="card">
        <div className="questionsHeader">
          <h3 className="cardTitle">📝 سوالات آزمون</h3>
          <span className="questionCount">{questions.length} سوال</span>
          {errors.questions && <div className="errorMsg">{errors.questions}</div>}
        </div>
        <div className="questionsContainer">
          {renderQuestionsList()}
        </div>
        <div className="totalScoreWrapper">
          {renderTotalScoreInfo()}
        </div>
      </section>

      {/* ===== پیش‌نمایش ===== */}
      {showPreview && (
        <section className="card previewCard">
          <h3 className="cardTitle">👁️ پیش‌نمایش آزمون</h3>
          <div className="previewContent">
            <div className="previewHeader">
              <h2>{examInfo.title || 'عنوان آزمون'}</h2>
              <p>{examInfo.book || 'کتاب'}</p>
              {examInfo.isGlobal && !examInfo.isChallenge && (
                <p>
                  🌍 آزمون عمومی - {examInfo.grade}
                  {examInfo.fieldTitle ? ` (${examInfo.fieldTitle})` : ''}
                  {examInfo.subject ? ` - ${examInfo.subject}` : ''}
                  {examInfo.chapter ? ` - فصل ${examInfo.chapter}` : ''}
                </p>
              )}
              {examInfo.isChallenge && (
                <p>
                  🏆 چالش ویژه - {examInfo.grade}
                  {examInfo.fieldTitle ? ` (${examInfo.fieldTitle})` : ''}
                  {examInfo.subject ? ` - ${examInfo.subject}` : ''}
                  {examInfo.chapter ? ` - فصل ${examInfo.chapter}` : ''}
                </p>
              )}
              <p>تاریخ: {examInfo.date || (examInfo.isGlobal ? 'نامشخص (آزمون عمومی)' : 'نامشخص')}</p>
              <p>تعداد سوالات: {questions.length}</p>
              <p>مدت زمان: {examInfo.duration || 'نامشخص'} دقیقه</p>
              <p>مجموع نمرات: {totalScore.toFixed(2)} از ۲۰</p>
            </div>
            <div className="previewQuestions">
              {questions.map((q, idx) => (
                <div key={q.id} className="previewQuestion">
                  <h4>سوال {idx + 1} (نمره: {toNumber(q.score, 1)}){q.type === 'essay' && ' - تشریحی'}{q.type === 'file' && ' - فایل'}{q.type === 'matching' && ' - تطبیقی'}{q.type === 'ordering' && ' - مرتب‌سازی'}</h4>
                  <p>{q.question}</p>
                  {q.mathFormula && <div className="previewMath">📐 فرمول: {q.mathFormula}</div>}
                  {q.image && <div className="previewImage"><img src={getImageUrl(q.image)} alt="تصویر سوال" /></div>}
                  {q.type === 'multiple' && <div className="previewOptions">{q.options.map((opt, oi) => <div key={oi} className="previewOption"><span>{String.fromCharCode(65 + oi)}. {opt}</span></div>)}</div>}
                  {q.type === 'multi' && <div className="previewOptions">{q.options.map((opt, oi) => <div key={oi} className="previewOption"><span>☑ {String.fromCharCode(65 + oi)}. {opt}</span></div>)}</div>}
                  {q.type === 'fill' && <div className="previewFill">{q.fillAnswers.map((_, fi) => <span key={fi} className="previewFillBlank">____</span>)}</div>}
                  {q.type === 'truefalse' && <div className="previewTrueFalse"><span>🔘 صحیح</span><span>🔘 غلط</span></div>}
                  {q.type === 'essay' && <div className="previewEssay"><textarea className="previewTextarea" placeholder="پاسخ خود را بنویسید..." rows="4" readOnly /></div>}
                  {q.type === 'file' && <div className="previewFile"><span>📎 آپلود فایل</span></div>}
                  {q.type === 'matching' && <div className="previewMatching">{q.matchingPairs.map((pair, mi) => <div key={mi} className="previewMatchingPair"><span>{pair.left}</span><span>⟷</span><span className="previewMatchingSelect">[انتخاب]</span></div>)}</div>}
                  {q.type === 'ordering' && <div className="previewOrdering">{q.orderItems.map((item, oi) => <div key={oi} className="previewOrderItem"><span>⬆⬇ {oi + 1}. {item}</span></div>)}</div>}
                </div>
              ))}
            </div>
          </div>
          <button className="btn btnOutline" onClick={() => setShowPreview(false)}>بستن پیش‌نمایش</button>
        </section>
      )}

      {/* ===== محتوای PDF مخفی ===== */}
      <div style={{ display: 'none' }}>
        <div ref={pdfContentRef} style={{
          fontFamily: 'Tahoma, sans-serif',
          padding: '30px 35px',
          direction: 'rtl',
          maxWidth: '100%',
          backgroundColor: '#ffffff',
          color: '#1a1a1a',
          fontSize: '14px',
          lineHeight: '1.8'
        }}>
          <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '15px', marginBottom: '25px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
              آزمون درس {examInfo.subject || ''}
            </h1>
            <h2 style={{ fontSize: '18px', fontWeight: '600', margin: '5px 0' }}>
              {examInfo.title || 'عنوان آزمون'}
            </h2>
            <p style={{ fontSize: '14px', margin: '4px 0', color: '#333' }}>
              {examInfo.grade || ''} - {examInfo.book || ''} {examInfo.chapter ? `- فصل ${examInfo.chapter}` : ''}
            </p>
            <p style={{ fontSize: '13px', margin: '4px 0', color: '#555' }}>
              تاریخ: {examInfo.date || ''} | مدت زمان: {examInfo.duration || ''} دقیقه | نوبت: {examInfo.isGlobal ? (examInfo.isChallenge ? 'چالش ویژه' : 'عمومی') : 'گروهی'}
            </p>
            <p style={{ fontSize: '13px', margin: '4px 0', color: '#555' }}>
              تعداد سوالات: {questions.length} | مجموع نمرات: {toPersianDigits(totalScore.toFixed(2))} از ۲۰
            </p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', padding: '10px 0', borderBottom: '1px dashed #ccc' }}>
            <span style={{ fontSize: '14px' }}>
              نام و نام خانوادگی: <span style={{ borderBottom: '1px solid #000', padding: '0 40px 0 0' }}>__________________</span>
            </span>
            <span style={{ fontSize: '14px' }}>
              کلاس: <span style={{ borderBottom: '1px solid #000', padding: '0 30px 0 0' }}>______</span>
            </span>
            <span style={{ fontSize: '14px' }}>
              تاریخ: <span style={{ borderBottom: '1px solid #000', padding: '0 30px 0 0' }}>______</span>
            </span>
          </div>

          {examInfo.description && (
            <div style={{ marginBottom: '20px', padding: '10px 15px', background: '#f7f7f7', borderRadius: '6px', border: '1px solid #e0e0e0' }}>
              <p style={{ fontSize: '13px', margin: '0', color: '#444' }}>{examInfo.description}</p>
            </div>
          )}

          {questions.map((q, idx) => (
            <div key={q.id} style={{ marginBottom: '22px', padding: '10px 0', borderBottom: '1px dashed #ddd' }}>
              <p style={{ fontWeight: 'bold', fontSize: '15px', margin: '0 0 8px 0', color: '#1a1a1a' }}>
                سوال {toPersianDigits(idx + 1)} {q.score ? `(${toPersianDigits(q.score.toFixed(1))} نمره)` : ''}
              </p>
              <p style={{ fontSize: '14px', margin: '0 0 10px 0', lineHeight: '1.9' }}>
                {q.question}
              </p>
              {q.type === 'multiple' && q.options && q.options.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.options.map((opt, oi) => (
                    <p key={oi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      {toPersianLetter(String.fromCharCode(65 + oi))}. {opt}
                    </p>
                  ))}
                </div>
              )}
              {q.type === 'multi' && q.options && q.options.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.options.map((opt, oi) => (
                    <p key={oi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      ☐ {toPersianLetter(String.fromCharCode(65 + oi))}. {opt}
                    </p>
                  ))}
                </div>
              )}
              {q.type === 'fill' && q.fillAnswers && q.fillAnswers.length > 0 && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  {q.fillAnswers.map((_, fi) => (
                    <p key={fi} style={{ fontSize: '13px', margin: '3px 0' }}>
                      جای خالی {toPersianDigits(fi + 1)}: ______________
                    </p>
                  ))}
                </div>
              )}
              {q.type === 'truefalse' && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  <p style={{ fontSize: '13px', margin: '3px 0' }}>○ صحیح</p>
                  <p style={{ fontSize: '13px', margin: '3px 0' }}>○ غلط</p>
                </div>
              )}
              {(q.type === 'essay' || q.type === 'file') && (
                <div style={{ marginRight: '20px', marginBottom: '6px' }}>
                  <div style={{ border: '1px solid #aaa', height: '70px', borderRadius: '4px', background: '#fafafa', marginTop: '4px' }}></div>
                  <p style={{ fontSize: '12px', color: '#888', margin: '4px 0 0 0' }}>فضای پاسخ‌دهی</p>
                </div>
              )}
              {q.mathFormula && (
                <p style={{ fontSize: '13px', color: '#555', margin: '5px 0' }}>
                  📐 فرمول: {q.mathFormula}
                </p>
              )}
            </div>
          ))}

          <div style={{ textAlign: 'center', marginTop: '30px', paddingTop: '20px', borderTop: '2px solid #000' }}>
            <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#1a1a1a' }}>با آرزوی موفقیت 🌟</p>
            <p style={{ fontSize: '12px', color: '#888', marginTop: '6px' }}>
              به نام خداوند بخشنده مهربان
            </p>
          </div>
        </div>
      </div>



      {/* ===== 🎯 NEW: انتخاب نوع انتشار آزمون (فقط برای ادمین) ===== */}
      {isAdmin && !isStepQuizMode && (
        <section className="card examPublishTypeCard">
          <h3 className="cardTitle">🎯 نوع انتشار آزمون</h3>
          <p className="examPublishTypeHint">
            مشخص کنید این آزمون به چه صورت منتشر شود:
          </p>
          <div className="examPublishTypeGrid">
            <button
              type="button"
              className={classNames(
                'examPublishTypeBtn',
                !examInfo.isGlobal && !examInfo.isChallenge && 'active'
              )}
              onClick={() =>
                setExamInfo((prev) => ({
                  ...prev,
                  isGlobal: false,
                  isChallenge: false,
                  isDailyChallenge: false,
                }))
              }
            >
              <span className="examPublishTypeIcon">📘</span>
              <span className="examPublishTypeTitle">دستی (گروهی)</span>
              <span className="examPublishTypeDesc">فقط برای گروه شما</span>
            </button>

            <button
              type="button"
              className={classNames(
                'examPublishTypeBtn',
                examInfo.isGlobal && !examInfo.isChallenge && 'active'
              )}
              onClick={() =>
                setExamInfo((prev) => ({
                  ...prev,
                  isGlobal: true,
                  isChallenge: false,
                  isDailyChallenge: false,
                }))
              }
            >
              <span className="examPublishTypeIcon">🌍</span>
              <span className="examPublishTypeTitle">عمومی</span>
              <span className="examPublishTypeDesc">برای همه دانش‌آموزان</span>
            </button>

            <button
              type="button"
              className={classNames(
                'examPublishTypeBtn',
                examInfo.isChallenge && 'active'
              )}
              onClick={() =>
                setExamInfo((prev) => ({
                  ...prev,
                  isGlobal: true,
                  isChallenge: true,
                }))
              }
            >
              <span className="examPublishTypeIcon">🏆</span>
              <span className="examPublishTypeTitle">چالش ویژه</span>
              <span className="examPublishTypeDesc">با جوایز سکه و XP</span>
            </button>
          </div>

          {examInfo.isChallenge && (
            <div className="examPublishTypeNote">
              💡 برای تنظیم جوایز چالش (سکه و XP) به بخش «⚙️ تنظیمات پیشرفته» مراجعه کنید.
            </div>
          )}

          {!examInfo.isGlobal && !examInfo.isChallenge && (
            <div className="examPublishTypeNote manual">
              📌 این آزمون فقط برای اعضای گروه شما در دسترس خواهد بود.
            </div>
          )}

          {examInfo.isGlobal && !examInfo.isChallenge && (
            <div className="examPublishTypeNote public">
              🌍 این آزمون برای همه دانش‌آموزان در همه گروه‌ها قابل مشاهده خواهد بود.
            </div>
          )}
        </section>
      )}

      <section className="footer">
        <button className="btn btnOutline" onClick={() => setShowPreview(!showPreview)}>👁️ پیش‌نمایش</button>
        <div className="footerRight">
          {!isStepQuizMode && (
            <button className="btn btnOutline btnLarge" onClick={goToPdfEditor}>📄 تبدیل به Pdf</button>
          )}
          <button className="btn btnSecondary btnLarge" onClick={() => handleSave(false)} disabled={saving}>
            {saving ? '⏳...' : isStepQuizMode ? '💾 ذخیره آزمون مرحله' : '💾 ذخیره موقت'}
          </button>
          <button
            className={`btn btnPrimary btnLarge ${!isTotalScoreValid ? 'btnDisabled' : ''}`}
            onClick={handlePublish}
            disabled={saving || !isTotalScoreValid}
          >
            {saving
              ? '⏳...'
              : isStepQuizMode
                ? '💾 ذخیره و بستن'
                : (isEditing ? '📤 به‌روزرسانی' : '🚀 انتشار برای دانش آموزان')}
          </button>
        </div>
      </section>
      {/* 🆕 مودال خرید اشتراک AI */}
      {showSubModal && (
        <div className="sub-modal-overlay" onClick={() => !subLoading && setShowSubModal(false)}>
          <div className="sub-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="sub-modal-close"
              onClick={() => setShowSubModal(false)}
              disabled={!!subLoading}
            >
              ✕
            </button>

            <div className="sub-modal-header">
              <div className="sub-modal-icon">🚀</div>
              <h2>ساخت نامحدود آزمون با AI</h2>
              <p>سهمیه رایگان امروز شما به پایان رسیده است</p>
              <p className="sub-modal-sub">با خرید اشتراک، بدون محدودیت روزانه آزمون بسازید</p>
            </div>

            <div className="sub-modal-plans">
              {Object.values(AI_PLANS).map((plan) => (
                <div key={plan.id} className={classNames('sub-plan-card', plan.badge && 'featured')}>
                  {plan.badge && <div className="sub-plan-badge">{plan.badge}</div>}
                  <h3 className="sub-plan-title">{plan.title}</h3>
                  <div className="sub-plan-price">{plan.priceLabel}</div>
                  <ul className="sub-plan-features">
                    {plan.features.map((f, i) => (
                      <li key={i}>✅ {f}</li>
                    ))}
                  </ul>
                  <button
                    className="btn btnPrimary sub-plan-btn"
                    onClick={() => handleBuySubscription(plan.id)}
                    disabled={!!subLoading}
                  >
                    {subLoading === plan.id ? '⏳ در حال انتقال...' : '🛒 خرید و فعال‌سازی'}
                  </button>
                </div>
              ))}
            </div>

            <div className="sub-modal-footer">
              <p>🔒 پرداخت امن از طریق درگاه بانکی</p>
              <button
                className="btn btnOutline"
                onClick={() => setShowSubModal(false)}
                disabled={!!subLoading}
              >
                بعداً
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateExamAI;